/*
  PDP variant bottom sheet — VWO experiment v1_c11074_j11355, shipped as-is.

  MOBILE ONLY. The body of this file is the experiment script verbatim; the only
  addition is the invocation gate at the very bottom, which requires
  (max-width: 749px) before starting. 749 is the theme's canonical mobile
  breakpoint (544 occurrences of 749/750 across the theme vs 19 of 768).

  Loaded deferred and only on product templates from layout/theme.liquid.
*/
window.v1_c11074_j11355 = function () {
  if (document.querySelector('.product.product--medium') && !document.getElementsByClassName('v1_c11074_j11355').length) {
    document.body.classList.add('v1_c11074_j11355');
    var heightData = {
      '6': 'For total sleeper weight less than 60 kg, use a 6-inch (15.24 cm) mattress.',
      '8': 'For total sleeper weight between 60-80 kg, use an 8-inch (20.32 cm) mattress.',
      '10': 'For total sleeper weight above 80 kg, use a 10-inch (25.4 cm) mattress.'
    };
    var downArrowSVG = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="#202020" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    // Some other script (e.g. window.MTOMessageManager) can show an MTO
    // block for the default/current variant id on its own timing, outside
    // our control and without a childList mutation we'd catch. A CSS
    // !important rule beats any inline display:block that script sets,
    // regardless of load timing. It's keyed off the v1SizeNotSelected body
    // class, which we toggle from the real DOM selection state on every
    // mutation pass (see v1SyncMtoGuardClass) — so the moment a dimension is
    // actually selected the class drops and the MTO block is allowed to show.
    if (!document.querySelector('#v1MtoHideStyle')) {
      document.head.insertAdjacentHTML(
        'beforeend',
        '<style id="v1MtoHideStyle">' +
          'body.v1SizeNotSelected .mto-message-container,' +
          'body.v1SizeNotSelected .mto-message-container [data-variant-id] {' +
            'display: none !important;' +
          '}' +
        '</style>'
      );
    }
    // Guard immediately so the MTO can't show before the first mutation pass or
    // before MTOMessageManager reveals the default variant on its own timing.
    document.body.classList.add('v1SizeNotSelected');
    var v1SelectedHeight = '';
    var v1SelectedDimension = '';
    var v1SelectedVariantId = '';
    var v1UserSelectedSize = false;
    var v1IsFirstLoad = true;
    var v1HasDimensionPicker = false;
    // Tracks whether the SHOPPER has actually picked a dimension. Shopify's
    // markup pre-selects the first variant (adds .selected in the raw DOM) on
    // page load, so we can't trust the DOM's .selected state to mean "the user
    // chose a size" — we only flip this true from v1SetSelectedDimension,
    // which runs on a real dimension click / re-apply of an existing choice.
    // Re-entrancy guard only — no debounce, so the callback runs on
    // every relevant mutation and can inject the drawer/CTAs as soon
    // as their parents appear.
    var v1IsMutating = false;
    function v1CleanNumber(value) {
      return (value || '').toString().replace(/[^0-9]/g, '');
    }
    function v1GetDimensionValue(el) {
      return (el && (el.getAttribute('data-value') || el.textContent || '').trim()) || '';
    }
    function v1GetDimensionHeight(el) {
      var height = v1CleanNumber(el && el.getAttribute('data-sizevalue'));
      if (height) {
        return height;
      }
      return v1CleanNumber(v1GetDimensionValue(el).split('x').pop());
    }
    // The chip that belongs to the variant currently committed to the buy form.
    //
    // Matched on the variant's OWN option values — both the chip's dimension string
    // and its data-option1 must be values that variant actually carries — so a
    // dimension shared by two categories (or two mattress types) cannot resolve to
    // the wrong one. Prefers a visible chip and falls back to a hidden match, then to
    // null, so the caller can fall back to its previous behaviour and this can never
    // make the selection worse than it was.
    function v1FindChipForCommittedVariant() {
      var input = document.querySelector('product-form input[name="id"]');
      var variantId = input && input.value;
      if (!variantId) {
        return null;
      }
      var variants = v1GetVariantData();
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) {
        return null;
      }
      var chips = document.querySelectorAll('.product_customDropdown.dimensions .dimension_val');
      var hiddenMatch = null;
      for (var c = 0; c < chips.length; c++) {
        var chip = chips[c];
        var chipDimension = v1GetDimensionValue(chip);
        if (!chipDimension) {
          continue;
        }
        if (!v1VariantHasAllValues(variant, [String(chipDimension).trim().toLowerCase()])) {
          continue;
        }
        var chipOwnValue = (chip.getAttribute('data-option1') || '').trim().toLowerCase();
        if (chipOwnValue && !v1VariantHasAllValues(variant, [chipOwnValue])) {
          continue;
        }
        if (!chip.classList.contains('hidden')) {
          return chip;
        }
        if (!hiddenMatch) {
          hiddenMatch = chip;
        }
      }
      return hiddenMatch;
    }
    // Make the DOM's dimension selection agree with the variant the page was actually
    // served for. Runs once, before any consumer reads the selection.
    //
    // WHY THIS EXISTS AT ALL: '.selected' on a chip is a RENDER ARTIFACT, not state.
    // product-variant-picker.liquid:680 stamps it on `forloop.first` unconditionally,
    // so the first chip is always marked selected no matter what ?variant= asked for.
    // Meanwhile input[name="id"] IS server-rendered from ?variant= and is correct.
    // Measured on /products/mattress-protector?variant=46048898679042
    // (King / Grey / 72 x 72): all 16 chips ship visible, the King category radio is
    // checked, the form carries the King variant — and the only '.selected' chip is
    // Single / 72 x 36.
    //
    // Correcting it HERE, once, is deliberate. The alternative was to make each
    // reader distrust the DOM, and there are many: v1FindSelectedVariant (:840),
    // v1ResetInitialDimensionSelection, v1ApplyDimensionFilter, plus product-info.js's
    // own chip lookups. One wrong fact fixed at its source beats N workarounds.
    function v1ReconcileSelectionWithCommittedVariant() {
      var chip = v1FindChipForCommittedVariant();
      if (!chip) {
        return false;
      }
      // Already agrees — leave the DOM completely alone.
      if (chip.classList.contains('selected') && !chip.classList.contains('hidden')) {
        return false;
      }
      document
        .querySelectorAll('.product_customDropdown.dimensions .dimension_val')
        .forEach(function (el) {
          if (el !== chip) {
            el.classList.remove('selected');
            el.removeAttribute('selected');
          }
        });
      chip.classList.remove('hidden');
      chip.classList.add('selected');
      chip.setAttribute('selected', 'selected');
      // data-selected is what product-info.js's selectedSizeClicked() reads first, and
      // what v1ApplyDimensionFilter falls back to for the current dimension.
      var button = document.querySelector(
        '.product_customDropdown.dimensions .custom-dropdown-button-text'
      );
      if (button) {
        button.setAttribute('data-selected', v1GetDimensionValue(chip));
      }
      return true;
    }
    function v1ResetInitialDimensionSelection() {
      // Skip the reset entirely for products without height options.
      // Those products have a single pre-selected variant on page load, and we
      // want to display that selection on the Select Size button rather than
      // forcing the user to manually pick (there's nothing to pick from).
      var hasHeightSelector = document.querySelectorAll(
        '.product-form__input.height .height_option'
      ).length > 0;
      if (!hasHeightSelector) {
        // Sync the in-page Select Size button to show the pre-selected variant.
        //
        // 2026-08-14: the buy form's variant id is SERVER-rendered from ?variant= and
        // is the authoritative answer on first load. The DOM's '.selected' chip is
        // NOT: product-variant-picker.liquid:680 marks `forloop.first` selected
        // unconditionally, so the first chip carries '.selected' no matter which
        // variant the URL asked for.
        //
        // Measured on /products/mattress-protector?variant=46048898679042
        // (King / Grey / 72 x 72), reading the raw server HTML: input[name="id"] was
        // correctly 46048898679042 and the King category radio was checked, but the
        // ONLY '.selected' chip was Single / 72 x 36. Taking the chip first therefore
        // resolved the Single variant and v1CommitSelectedVariantToMainATC() wrote it
        // into the buy form and rewrote the URL to it — so deep links, "back" from
        // cart, and any shared ?variant= link silently lost the chosen size. Opening
        // the sheet then showed the right category's chips with NONE selected,
        // because v1SelectedDimension held Single's "72 x 36".
        //
        // Verified the same run: with the sheet blocked the page was correct
        // end-to-end, which is what isolated this to the sheet.
        //
        // Fixed at the SOURCE rather than here. An earlier attempt resolved the chip
        // locally and assigned v1SelectedDimension / v1SelectedVariantId before
        // calling v1CommitSelectedVariantToMainATC() — and changed nothing, because
        // that function takes no arguments and re-derives the variant itself through
        // v1FindSelectedVariant(), which anchors on the very '.selected' chip that is
        // wrong (:840). Teaching one caller to work around the bad DOM left every
        // other reader still reading it. v1ReconcileSelectionWithCommittedVariant()
        // corrects the DOM once, before anything reads it, so this query — and
        // v1FindSelectedVariant, v1ApplyDimensionFilter and product-info.js's own
        // lookups — all see the truth without needing to know about the problem.
        v1ReconcileSelectionWithCommittedVariant();
        var preSelectedDim = document.querySelector(
          '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
        );
        if (preSelectedDim) {
          // Internal state setup
          v1SelectedDimension = v1GetDimensionValue(preSelectedDim);
          var matchedVariant = v1FindVariantForDimensionEl(preSelectedDim);
          if (matchedVariant) v1SelectedVariantId = matchedVariant.id;
          // Update the in-page Select Size button + main ATC
          v1CommitSelectedVariantToMainATC();
        } else {
          // No dimension preselected (e.g. dropdown style), but variant input
          // already has a value — try to find that variant and commit
          var variantId = document.querySelector('product-form input[name="id"]')?.value;
          if (variantId) {
            var variants = v1GetVariantData();
            var matchedVariant = variants.find(function (v) {
              return String(v.id) === String(variantId);
            });
            if (matchedVariant) {
              v1SelectedVariantId = matchedVariant.id;
              v1SyncSelectedVariantAndPrice(matchedVariant);
            }
          }
        }
        return; // don't run the reset logic below
      }
      // Original reset logic, only for products WITH height options:
      // remove selected class
      document.querySelectorAll('.product_customDropdown.dimensions .dimension_val').forEach(function (el) {
        el.classList.remove('selected');
        el.removeAttribute('selected');
      });
      // reset dropdown text
      var btn = document.querySelector('.product_customDropdown.dimensions .custom-dropdown-button-text');
      if (btn) {
        btn.textContent = 'Select a size';
        btn.removeAttribute('data-selected');
      }
      // reset internal state
      v1SelectedDimension = '';
      v1SelectedVariantId = '';
      // disable ATC
      document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function (btn) {
        btn.setAttribute('disabled', 'disabled');
      });
      document.body.classList.add('v1NoSizeSelected');
    }
    function v1GetSelectedCategory() {
      var customCategory = document.querySelector(
        'variant-selects .variant-pill-list.category .custom-size.active label'
      );
      if (customCategory) {
        return customCategory.textContent.trim();
      }
      var checked = document.querySelector('variant-selects .variant-pill-list.category input:checked');
      return (checked && checked.value && checked.value.trim()) || '';
    }
    function v1GetCurrentHeight() {
      if (v1SelectedHeight) {
        return v1SelectedHeight;
      }
      var activeHeight = document.querySelector('.height_option.active');
      if (activeHeight) {
        return v1CleanNumber(activeHeight.getAttribute('data-value') || activeHeight.textContent);
      }
      var selectedDimension = document.querySelector(
        '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
      );
      if (selectedDimension) {
        return v1GetDimensionHeight(selectedDimension);
      }
      // var firstHeight = document.querySelector('.height_option');
      // if (firstHeight) {
      //   return v1CleanNumber(firstHeight.getAttribute('data-value') || firstHeight.textContent);
      // }
      return '';
    }
    function v1SetActiveHeight(heightValue) {
      heightValue = v1CleanNumber(heightValue);
      if (!heightValue) {
        return;
      }
      v1SelectedHeight = heightValue;
      document.querySelectorAll('.height_option').forEach(function (el) {
        var thisHeight = v1CleanNumber(el.getAttribute('data-value') || el.textContent);
        if (thisHeight === heightValue) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    }
    function v1NormalizeOptionText(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .replace(/\u00a0/g, ' ')
        .replace(/\s*inches?\s*$/i, '')
        .replace(/\s+/g, '')
        .trim();
    }
    function v1NormalizeDimensionNumbers(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .replace(/\u00a0/g, ' ')
        .replace(/inches?/g, '')
        .replace(/[^\d]+/g, 'x')
        .replace(/^x+|x+$/g, '');
    }
    /*
      Single-value option groups.

      Roughly half the catalogue ships option groups that offer no actual
      choice. Two shapes produce it:

        globally constant  - the option has one value across every variant
                             (e.g. every pillow-case product is "2 cases";
                             every ErgoVerse cushion has one DIMENSION)
        determined         - the option is decided by an earlier one, so once
                             that is picked a single value remains (e.g. the
                             comforter's DIMENSION is 90 x 60 for Single and
                             90 x 100 for Double)

      Both end up rendering exactly one row, which reads as a control the
      shopper is expected to operate. The value is still worth showing, so the
      row is kept and the affordance is stripped in CSS rather than the group
      being hidden -- that also keeps the node live for the inch/cm/feet
      converter and for the variant-sync code, neither of which needs to know
      this happened.

      Marked with an attribute rather than a class so it cannot collide with
      the theme's own class churn on these elements.
    */
    var V1_SINGLE_VALUE_ATTR = 'data-v1-single-value';
    /*
      Stops at 2. The mattress dimension list is 156 rows, and all we ever ask
      is "more than one?", so there is no reason to walk past the second
      distinct value.
    */
    function v1CountDistinctUpToTwo(nodes, readValue) {
      var seen = Object.create(null);
      var found = 0;
      for (var i = 0; i < nodes.length; i++) {
        var key = v1NormalizeOptionText(readValue(nodes[i]));
        if (!key || seen[key]) {
          continue;
        }
        seen[key] = true;
        found++;
        if (found > 1) {
          return found;
        }
      }
      return found;
    }
    function v1ReadNodeDataValue(el) {
      return el.getAttribute('data-value') || el.textContent;
    }
    function v1ReadInputValue(el) {
      return el.value;
    }
    /*
      Marks one option group. Called from the pass's existing group loop rather
      than from a query of its own -- a second querySelectorAll over
      <variant-selects> would be a full second subtree walk every pass, and that
      subtree is 600+ elements on a mattress PDP (156 pills + 156 dimension
      rows).

      .product-type is skipped deliberately. It is not a variant option -- it is
      the linked-product switcher (Standard / King / Cuddle are three separate
      products), and every one of its radios carries the *same* value, so
      counting distinct values would read it as a single-value group and flatten
      a live set of links.
    */
    function v1MarkSingleValueGroup(group, selectedCategory) {
      if (group.classList.contains('product-type')) {
        return;
      }
      var isDimensionDropdown = group.classList.contains('dimensions');
      if (
        !isDimensionDropdown &&
        !group.classList.contains('variant-pill-list') &&
        !group.classList.contains('product-form__input--swatch')
      ) {
        return;
      }
      /*
        Pill and swatch option sets are server-rendered and never change after
        first paint, so they are measured once and the answer is cached on the
        node -- every later pass exits on the key comparison below without
        touching the DOM. The dimension list is the only group re-filtered at
        runtime (v1ApplyDimensionFilter() adds .hidden to the rows that don't
        belong to the selected category), so it is the only one re-measured, and
        only when the category actually changes.

        The 'filtered' half of the key exists because the very first pass can run
        before that filter has been applied, when every row is still visible and
        the count would be wrong. querySelector (singular) bails on the first
        match, so this stays cheap on the 156-row lists.
      */
      var cacheKey = isDimensionDropdown
        ? selectedCategory +
          '|' +
          (group.querySelector('.dimension_val.hidden') ? 'filtered' : 'raw')
        : 'static';
      if (group.v1SingleValueKey === cacheKey) {
        return;
      }
      group.v1SingleValueKey = cacheKey;
      var distinctValues;
      if (isDimensionDropdown) {
        distinctValues = v1CountDistinctUpToTwo(
          group.querySelectorAll('.dimension_val:not(.hidden)'),
          v1ReadNodeDataValue
        );
        /*
          Fail-safe. For products with height options
          v1ResetInitialDimensionSelection() deliberately clears the
          pre-selection, and the dimension list is then the only way to make one
          -- stripping its affordance would leave Add to Cart gated with nothing
          to tap. No product in the catalogue currently hits this (every
          determined-dimension product has zero height options), but a merchant
          adding one later must not be able to create a dead end, so an
          unselected list is treated as a real choice.
        */
        if (
          distinctValues === 1 &&
          !group.querySelector('.dimension_val.selected:not(.hidden)')
        ) {
          distinctValues = 2;
        }
      } else if (group.querySelector('.height_option')) {
        distinctValues = v1CountDistinctUpToTwo(
          group.querySelectorAll('.height_option'),
          v1ReadNodeDataValue
        );
      } else {
        distinctValues = v1CountDistinctUpToTwo(
          group.querySelectorAll('input[type="radio"]'),
          v1ReadInputValue
        );
        // The "custom size" pill is a real choice but carries no radio.
        if (group.querySelector('.variant-pill.custom-size')) {
          distinctValues++;
        }
      }
      // 0 means nothing has rendered yet -- leave those alone.
      if (distinctValues === 1) {
        group.setAttribute(V1_SINGLE_VALUE_ATTR, '');
        if (isDimensionDropdown) {
          v1SetCollapsedDimensionPrefix(group);
        }
      } else {
        group.removeAttribute(V1_SINGLE_VALUE_ATTR);
      }
    }
    /*
      The collapsed dimension row leads with the size it belongs to --
      "Double | 90 x 100 inches" -- so it reads the same way as the in-page
      "Select Size" summary rather than as a bare measurement.

      Carried as an attribute and drawn with ::before instead of being pushed
      into the row's text, because the theme's inch/cm/feet converter rewrites
      that text node wholesale: a prepended prefix would be dropped on the first
      unit switch, and until then would be fed through the converter's own
      number parsing.

      Falls back to the bare dimension where there is no category group at all
      (ErgoVerse cushions, pillows), which is what the in-page summary does too.
    */
    function v1SetCollapsedDimensionPrefix(group) {
      var visibleRow = group.querySelector('.dimension_val:not(.hidden)');
      if (!visibleRow) {
        return;
      }
      var sizeSource = v1GetDisplaySizeSource();
      /*
        Suppressed when the size is itself a single fixed value, because it is
        then already sitting as static text one row above and the prefix would
        restate the same constant twice running (the slim pillow reads
        "SIZE: Standard" / "Standard | 26 x 16 x 3"). The prefix exists to pair
        the dimension with a size the shopper actually chose.
      */
      if (sizeSource.value && !v1IsSingleValueGroup(sizeSource.group)) {
        visibleRow.setAttribute('data-v1-size-prefix', sizeSource.value + ' | ');
      } else {
        visibleRow.removeAttribute('data-v1-size-prefix');
      }
    }
    /*
      The size a shopper would read off the page, for display only.

      Reads the two option groups the theme actually classifies as a size --
      CATEGORY and SIZE -- and nothing else. Products with neither (the
      pillow-case family, whose Standard/King/Cuddle are separate products
      reached through the linked-product switcher rather than variants of one)
      have no size in their variant data, and are left showing the bare
      dimension instead of having one inferred from link text.

      Kept separate from v1GetSelectedCategory() on purpose: that value is
      matched against each row's data-option1 in v1ApplyDimensionFilter(), where
      a wrong value would match nothing and silently hide every dimension.

      Returns the group as well, so callers can tell a size the shopper chose
      from one that was fixed all along.
    */
    function v1GetDisplaySizeSource() {
      var category = v1GetSelectedCategory();
      if (category) {
        return {
          value: category,
          group: document.querySelector('variant-selects .variant-pill-list.category')
        };
      }
      var sizeGroup = document.querySelector('variant-selects .variant-pill-list.size');
      var checkedSize = sizeGroup && sizeGroup.querySelector('input:checked');
      if (checkedSize && checkedSize.value) {
        return { value: checkedSize.value.trim(), group: sizeGroup };
      }
      return { value: '', group: null };
    }
    function v1IsSingleValueGroup(group) {
      return !!(group && group.hasAttribute(V1_SINGLE_VALUE_ATTR));
    }
    /*
      The dimension dropdown ships under one of two mutually exclusive classes.
      product-variant-picker.liquid:551 writes them as alternates:

        class="product_customDropdown dimension_data
               {% if option_name == 'dimension' or option_name == 'DIMENSION' %}
                 dimensions
               {% else %}
                 dimension-size
               {% endif %}"

      so a product whose option is named "DIMENSION SIZE" -- the four pet-bed
      products -- gets .dimension-size and is missed by all 26 JS and 10 CSS
      selectors in this file, which only ever say .dimensions. The visible
      result is the raw dropdown button surviving inside the sheet instead of
      being replaced by the chip grid, and an empty in-page summary.

      Normalising the class here fixes every one of those selectors at once.
      Verified safe: nothing outside this file consumes
      .product_customDropdown.dimensions, so adding it cannot reach theme code.

      Re-checked each pass rather than latched behind a flag, because the
      Section Rendering API can replace this node and a latched flag would leave
      the replacement unnormalised. :not(.dimensions) means it stops matching as
      soon as the work is done.
    */
    /*
      The selected value of every group that still offers a choice, in the order
      the theme renders them. Used to label products that have no size at all --
      the colour on an ErgoVerse cushion, the pack size on a slim pillow.

      Groups already collapsed to one value are skipped: they add nothing the
      shopper decided. The dimension list is skipped because it is appended
      separately, and so is the hidden .dimension pill fieldset that shadows it,
      which would otherwise contribute the same measurement twice.
    */
    function v1GetChoosableOptionValues(optionGroups) {
      var values = [];
      for (var i = 0; i < optionGroups.length; i++) {
        var group = optionGroups[i];
        if (
          v1IsSingleValueGroup(group) ||
          group.classList.contains('dimensions') ||
          group.classList.contains('dimension') ||
          group.classList.contains('dimension-size')
        ) {
          continue;
        }
        var checkedInput = group.querySelector('input:checked');
        if (checkedInput && checkedInput.value) {
          values.push(checkedInput.value.trim());
        }
      }
      return values;
    }
    function v1NormaliseDimensionDropdownClass() {
      var altClassDropdown = document.querySelector(
        '.product_customDropdown.dimension-size:not(.dimensions)'
      );
      if (altClassDropdown) {
        altClassDropdown.classList.add('dimensions');
      }
    }
    function v1SelectHiddenDimensionInput(dimensionValue) {
      if (!dimensionValue) {
        return;
      }
      var matchingInput = null;
      var normalizedDimension = v1NormalizeOptionText(dimensionValue);
      var normalizedDimensionNumbers = v1NormalizeDimensionNumbers(dimensionValue);
      var dimensionInputs = document.querySelectorAll(
        'variant-selects .variant-pill-list.dimension input[type="radio"], ' +
        'variant-selects .variant-pill-list.dimension-size input[type="radio"]'
      );
      // PERF (2026-08-06): was a forEach over all 156 radios on a mattress PDP with
      // no early exit — 2 regex normalisations per node, ~312 regex executions per
      // dimension tap, every tap.
      //
      // Iterating BACKWARDS and breaking on the first hit is not the same as
      // iterating forwards and breaking: the original forEach reassigned
      // `matchingInput` on every match, so the LAST match in document order won.
      // The catalogue does contain repeated dimension values (pillow-cases renders
      // six rows all reading "28 x 18"), so first-vs-last decides which variant is
      // committed. Reverse + break preserves last-match-wins exactly.
      for (var i = dimensionInputs.length - 1; i >= 0; i--) {
        var inputValue = (dimensionInputs[i].value || '').trim();
        if (
          v1NormalizeOptionText(inputValue) === normalizedDimension ||
          v1NormalizeDimensionNumbers(inputValue) === normalizedDimensionNumbers
        ) {
          matchingInput = dimensionInputs[i];
          break;
        }
      }
      if (!matchingInput) {
        return;
      }
      var groupName = matchingInput.name;
      if (groupName) {
        // Trim and escape the name to avoid breaking the selector with stray
        // whitespace or special characters inside the attribute value.
        var safeName = groupName.trim().replace(/(["\\])/g, '\\$1');
        try {
          document.querySelectorAll('input[type="radio"][name="' + safeName + '"]').forEach(function (sibling) {
            if (sibling !== matchingInput) {
              sibling.checked = false;
            }
          });
        } catch (err) {
          // Fallback: iterate all radios and match by name comparison instead of selector
          document.querySelectorAll('input[type="radio"]').forEach(function (sibling) {
            if (sibling.name && sibling.name.trim() === safeName && sibling !== matchingInput) {
              sibling.checked = false;
            }
          });
        }
      }
      var matchingLabel = matchingInput.id
        ? document.querySelector('label[for="' + matchingInput.id + '"]')
        : null;
      if (matchingLabel) {
        matchingLabel.click();
      } else {
        matchingInput.checked = true;
        matchingInput.dispatchEvent(new Event('input', { bubbles: true }));
        matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    function v1EnsureCustomSizeDefaults() {
      // Backfill Custom Size's length/width with sane defaults when left
      // blank, so the site's own custom-size validation always sees valid
      // values — regardless of which category is currently active.
      var lengthInput = document.querySelector('.custom-size-wrapper input[name="custom-length"]');
      var widthInput = document.querySelector('.custom-size-wrapper input[name="custom-width"]');
      [[lengthInput, '60'], [widthInput, '40']].forEach(function (pair) {
        var input = pair[0];
        var defaultValue = pair[1];
        if (input && !input.value) {
          input.value = defaultValue;
          input.setAttribute('value', defaultValue);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    /*
      OPTIMISATION: the parsed variant list is cached.

      Measured before this change: a single size tap ran 30 parses of the 20 KB
      data-variants payload -- 637 KB parsed per tap -- because this function is
      called from v1FindSelectedVariant, v1FindVariantForDimensionEl and several
      other helpers, each of which the mutation pass invokes repeatedly.
      (The two original callers named here, v1UpdateMTOMessage and
      v1RefreshProductShape, have since been removed — the cache still matters
      for the callers that remain.)

      The attribute is server-rendered and never mutated, so one parse is
      correct. The empty case is deliberately NOT cached: this can be called
      before <variant-selects> is in the DOM, and caching [] then would leave it
      permanently empty.
    */
    var v1VariantDataCache = null;
    function v1GetVariantData() {
      if (v1VariantDataCache) {
        return v1VariantDataCache;
      }
      var variantSelects = document.querySelector('variant-selects[data-variants]');
      if (!variantSelects) {
        return [];
      }
      try {
        var parsed = JSON.parse(variantSelects.getAttribute('data-variants') || '[]');
      } catch (err) {
        return [];
      }
      if (parsed && parsed.length) {
        v1VariantDataCache = parsed;
      }
      return parsed || [];
    }
    // Renders the chosen size on its own line directly beneath the
    // "Dimension: … | inch cm feet" row, leaving that row intact on one line.
    //
    // Reads the selected chip's VISIBLE TEXT rather than v1GetSelectedDimensionValue()
    // below: that helper returns the raw data-value, which stays in inches, while the
    // theme's unit converter rewrites only the chip text. Using data-value here would
    // print inches under a grid showing cm. Text follows the converter for free.
    function v1UpdateSelectedDimensionLine() {
      var labelWrap = document.querySelector('.dimension_data .dimension-label-wrap');
      if (!labelWrap || !labelWrap.parentElement) {
        return;
      }
      var line = labelWrap.parentElement.querySelector('.v1SelectedDimensionLine');
      if (!line) {
        labelWrap.insertAdjacentHTML(
          'afterend',
          '<div class="v1SelectedDimensionLine" hidden></div>'
        );
        line = labelWrap.parentElement.querySelector('.v1SelectedDimensionLine');
        if (!line) {
          return;
        }
      }
      // Single-value groups already print their one value as static text in the
      // collapsed row (PROJECT_TRACKER Deviation #15) and their label reads
      // "Dimension:" rather than "Select Dimension:". Repeating it here would be the
      // same double-print this line was added to remove.
      var dimensionGroup = document.querySelector('.product_customDropdown.dimensions');
      if (dimensionGroup && dimensionGroup.hasAttribute('data-v1-single-value')) {
        if (!line.hidden) {
          line.hidden = true;
          line.textContent = '';
        }
        return;
      }
      var selectedChip = document.querySelector(
        '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
      );
      var value = selectedChip ? selectedChip.textContent.trim().replace(/\s+/g, ' ') : '';
      if (!value) {
        // Fall back to the resolved value for shapes with no visible chip grid.
        value = v1GetSelectedDimensionValue();
      }
      if (!value) {
        if (!line.hidden) {
          line.hidden = true;
          line.textContent = '';
        }
        return;
      }
      if (line.hidden) {
        line.hidden = false;
      }
      // textContent, not innerHTML — this string comes from merchant-authored
      // option values rendered into the DOM.
      if (line.textContent !== value) {
        line.textContent = value;
      }
    }
    function v1GetSelectedDimensionValue() {
      var selDim = document.querySelector('.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)');
      var btn = document.querySelector('.product_customDropdown.dimensions .custom-dropdown-button-text');
      var selectedDimension =
        v1SelectedDimension ||
        (selDim && selDim.getAttribute('data-value')) ||
        (btn && btn.getAttribute('data-selected')) ||
        (btn && btn.textContent && btn.textContent.trim()) ||
        '';
      if (selectedDimension.toLowerCase() === 'select a size') {
        selectedDimension = '';
      }
      return selectedDimension.trim();
    }
    function v1VariantMatchesDimensionEl(variant, dimensionEl) {
      if (!variant || !dimensionEl) {
        return false;
      }
      var dimensionCategory = (dimensionEl.getAttribute('data-option1') || v1GetSelectedCategory() || '').trim();
      var dimensionValue = v1GetDimensionValue(dimensionEl);
      if (!dimensionCategory || !dimensionValue) {
        return false;
      }
      var categoryKey = v1NormalizeOptionText(dimensionCategory);
      var dimensionKey = v1NormalizeOptionText(dimensionValue);
      var dimensionNumberKey = v1NormalizeDimensionNumbers(dimensionValue);
      var options = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      options = options.filter(Boolean);
      var normalizedOptions = options.map(v1NormalizeOptionText);
      var normalizedNumberOptions = options.map(v1NormalizeDimensionNumbers);
      var categoryMatch = normalizedOptions.indexOf(categoryKey) > -1;
      var dimensionMatch =
        normalizedOptions.indexOf(dimensionKey) > -1 ||
        normalizedNumberOptions.indexOf(dimensionNumberKey) > -1;
      return categoryMatch && dimensionMatch;
    }
    // Every option the shopper has picked OTHER than category and dimension —
    // in practice Colour/Style, which exists on the bedsheet/duvet products but
    // on no mattress.
    //
    // Deliberately NOT scoped to '.variant-pill-list' the way
    // v1GetActiveOptionValues() is: colour is rendered as
    // '.product-form__input--swatch', so a .variant-pill-list scope misses it
    // entirely. Same validation rule though — a checked control only counts if
    // its value is a real variant option value on this product, which keeps the
    // synthetic height radio (value "on") and the product-type switcher (whose
    // values are other products' TITLES) out.
    function v1GetOtherSelectedOptionValues() {
      var real = v1GetRealOptionValues();
      var values = [];
      document
        .querySelectorAll('variant-selects input[type="radio"]:checked')
        .forEach(function (input) {
          var group = input.closest('.variant-pill-list, .product-form__input, fieldset');
          if (
            group &&
            (group.classList.contains('dimension') ||
              group.classList.contains('dimension-size') ||
              group.classList.contains('category'))
          ) {
            return;
          }
          var value = String(input.value || '').trim().toLowerCase();
          if (!value || !real[value]) {
            return;
          }
          if (values.indexOf(value) === -1) {
            values.push(value);
          }
        });
      return values;
    }
    function v1VariantMatchesOtherSelections(variant) {
      if (!variant) {
        return false;
      }
      return v1VariantHasAllValues(variant, v1GetOtherSelectedOptionValues());
    }
    function v1FindVariantForDimensionEl(dimensionEl) {
      var variants = v1GetVariantData();
      if (!variants.length || !dimensionEl) {
        return null;
      }
      // A (category, dimension) pair does NOT identify a variant on every
      // product. The bedsheets are CATEGORY / DIMENSION / COLOUR-STYLE, so
      // "Queen + 78 x 60" matches six variants, one per colour — and .find()
      // took the first, which is how a shopper who picked Evergreen had Purple
      // Panther stamped into the buy form by v1CommitSelectedVariantToMainATC()
      // and added to their cart. Verified live: form id + properties[_VariantTitle]
      // both read "Queen / 78 x 60 / Purple Panther" while the URL, the sticky
      // bar and the checked swatch all said Evergreen.
      //
      // Prefer the candidate that also satisfies every other selected option,
      // and fall back to the plain category+dimension match when none does — so
      // a transiently inconsistent colour (the site unchecks colours that don't
      // exist under a newly picked category) can never make this return null
      // where it previously returned a variant.
      var matches = variants.filter(function (variant) {
        return v1VariantMatchesDimensionEl(variant, dimensionEl);
      });
      if (!matches.length) {
        return null;
      }
      // Read the selections ONCE, not per candidate — this runs on every
      // mutation pass and the DOM query would otherwise repeat up to 65 times
      // per resolution on the latex mattress.
      var otherValues = v1GetOtherSelectedOptionValues();
      if (!otherValues.length) {
        return matches[0];
      }
      for (var i = 0; i < matches.length; i++) {
        if (v1VariantHasAllValues(matches[i], otherValues)) {
          return matches[i];
        }
      }
      return matches[0];
    }
    function v1FindSelectedVariant() {
      var variants = v1GetVariantData();
      if (!variants.length) {
        return null;
      }
      /*
        CUSTOM SIZE short-circuits everything below.

        The category/dimension resolution that follows anchors on the
        '.dimension_val.selected' chip, which in custom size mode still holds
        whatever STANDARD size was picked before the shopper switched — or, on a
        cold load, nothing at all. Both answers are wrong here, and every
        consumer of this function (price sync, the buy form's id, the drawer
        thumbnail, the delivery block's cache key, the ATC gate) inherited that.

        Deliberately returns v1GetCustomSizeVariant()'s null rather than falling
        through: "the theme has not matched a size yet" must not degrade into
        "use the previous standard size".
      */
      if (v1IsCustomSizeActive()) {
        return v1GetCustomSizeVariant();
      }
      var selectedDimensionEl = document.querySelector(
        '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
      );
      if (v1SelectedVariantId && selectedDimensionEl) {
        var variantById = variants.find(function (variant) {
          return String(variant.id) === String(v1SelectedVariantId);
        });
        // The remembered id also has to still agree with the OTHER selected
        // options. Changing only the colour leaves category+dimension untouched,
        // so without this the previous colour's variant kept passing and got
        // re-stamped onto the buy form.
        if (
          variantById &&
          v1VariantMatchesDimensionEl(variantById, selectedDimensionEl) &&
          v1VariantMatchesOtherSelections(variantById)
        ) {
          return variantById;
        }
      }
      if (selectedDimensionEl) {
        return v1FindVariantForDimensionEl(selectedDimensionEl);
      }
      var selectedCategory = v1GetSelectedCategory();
      var selectedDimension = v1GetSelectedDimensionValue();
      if (!selectedCategory || !selectedDimension) {
        return null;
      }
      var categoryKey = v1NormalizeOptionText(selectedCategory);
      var dimensionKey = v1NormalizeOptionText(selectedDimension);
      var dimensionNumberKey = v1NormalizeDimensionNumbers(selectedDimension);
      return variants.find(function (variant) {
        var options = Array.isArray(variant.options)
          ? variant.options
          : [variant.option1, variant.option2, variant.option3];
        options = options.filter(Boolean);
        var normalizedOptions = options.map(v1NormalizeOptionText);
        var normalizedNumberOptions = options.map(v1NormalizeDimensionNumbers);
        return (
          normalizedOptions.indexOf(categoryKey) > -1 &&
          (
            normalizedOptions.indexOf(dimensionKey) > -1 ||
            normalizedNumberOptions.indexOf(dimensionNumberKey) > -1
          )
        );
      }) || null;
    }
    function v1FormatMoney(cents) {
      var amount = Number(cents);
      if (isNaN(amount)) {
        return '';
      }
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }).format(amount / 100);
    }
    /*
      Drawer thumbnail source: the selected variant's own image when it has
      one, otherwise the PRODUCT-level featured image.

      Two things to know:
      - Shape asymmetry. variant.featured_image is an OBJECT with .src;
        product.featured_image is a bare URL STRING. Verified on this store.
      - Both come back protocol-relative ("//sleepycat.in/cdn/..."), so they
        need a scheme before being set as a src.

      The product image is read from the inert #ProductJson island (the same
      source product-info.js uses for window.productData) rather than scraped
      from the gallery DOM: it is available immediately, needs no gallery to
      have rendered, and is the actual product-level featured image rather than
      whichever slide happens to be first.
    */
    // The product JSON, read once. window.productData is what product-info.js
    // uses; the inert #ProductJson island it is built from is the fallback for
    // the window between parse and assignment. Cached with a sentinel rather
    // than a falsy check so a page with no product island is not re-parsed on
    // every mutation pass.
    var v1ProductData;
    var v1ProductDataRead = false;
    function v1GetProductData() {
      if (v1ProductDataRead) {
        return v1ProductData;
      }
      v1ProductDataRead = true;
      var data = window.productData;
      if (!data) {
        var island = document.querySelector('#ProductJson');
        try {
          data = island ? JSON.parse(island.textContent) : null;
        } catch (err) {
          data = null;
        }
      }
      v1ProductData = data;
      return v1ProductData;
    }
    var v1ProductFeaturedImage = null;
    function v1GetProductFeaturedImage() {
      // Cached — this never changes, and re-parsing the product JSON on every
      // mutation pass would be expensive on a 49-variant product.
      if (v1ProductFeaturedImage !== null) {
        return v1ProductFeaturedImage;
      }
      var data = v1GetProductData();
      v1ProductFeaturedImage = (data && data.featured_image) || '';
      return v1ProductFeaturedImage;
    }
    /*
      Is this a mattress PDP?

      Keyed on product.type, which is the theme's own convention for exactly
      this question — product-variant-picker.liquid:825 already uses
      `product.type == 'Mattresses'` to decide whether to show the exchange
      note.

      NOT matched on the handle or title: "mattress-protector",
      "lycra-mattress-protector" and "quilted-mattress-protector" all contain
      "mattress" but are type Bedding, so a substring match would wrongly show
      the measure prompt on all three.

      Store-wide, type == 'Mattresses' covers 16 products: the 10 mattresses,
      5 mattress toppers and the mattress cover — all of which are sized against
      the bed, so the "measure your bed right" prompt applies to each.
    */
    var v1ProductType = null;
    function v1GetProductType() {
      if (v1ProductType !== null) {
        return v1ProductType;
      }
      var data = v1GetProductData();
      v1ProductType = (data && data.type) || '';
      return v1ProductType;
    }
    var v1ProductHandle = null;
    function v1GetProductHandle() {
      if (v1ProductHandle !== null) {
        return v1ProductHandle;
      }
      var data = v1GetProductData();
      v1ProductHandle = (data && data.handle) || '';
      return v1ProductHandle;
    }
    /*
      Dispatch-day estimate for the made-to-order / custom-size line.

      MIRRORS snippets/mto-dispatch-days.liquid, which is the canonical rule and
      already drives the PDP's own MTO banner (main-product.liquid:1794), the cart
      rows and the cart drawer. assets/bundle.js:44-53 carries the same mirror for
      the bundle selector. Keep all three in step: mattresses go out in 6 days,
      the Founder's Mattress in 9, everything else stays on the standard 3-day
      window.

      Matched on HANDLE, exactly as the snippet does — NOT on v1IsMattressProduct(),
      which keys on product.type. Type `Mattresses` also covers the 5 toppers and
      the mattress cover, and those are not on the 6-day window; using it here
      would quietly promise the wrong date on six products.
    */
    var V1_MTO_MATTRESS_HANDLES = [
      'original-mattress', 'latex-mattress', 'plus-mattress', 'ultima-natural-latex-mattress',
      'cloud-mattress', 'founders-mattress', 'the-latex-ortho-mattress', 'tri-fold-mattress',
      'baby-mattress', 'natural-latex-baby-mattress'
    ];
    function v1GetMtoDispatchDays() {
      var handle = v1GetProductHandle();
      if (handle === 'founders-mattress') {
        return 10;
      }
      return V1_MTO_MATTRESS_HANDLES.indexOf(handle) > -1 ? 8 : 3;
    }
    function v1IsMattressProduct() {
      // Case/whitespace tolerant so a merchant editing the type in admin
      // ("mattresses", " Mattresses") does not silently drop the prompt.
      return String(v1GetProductType()).trim().toLowerCase() === 'mattresses';
    }
    // Beds must be confirmed deliverable before they can be added to the cart, so
    // the delivery block renders on them regardless of MTO or custom size.
    //
    // Reads window.productData.type — NOT the pincode input's data-producttype,
    // which carries the review-widget override (`custom.review_product_type`) and
    // reads "bedbase_ohayo" rather than "bed" on the Ohayo bed.
    function v1IsBedProduct() {
      return String(v1GetProductType()).trim().toLowerCase() === 'bed';
    }
    function v1SizedImage(src, width) {
      if (!src) {
        return '';
      }
      var url = String(src);
      if (url.indexOf('//') === 0) {
        url = 'https:' + url;
      }
      if (url.indexOf('width=') > -1) {
        return url;
      }
      // The slot renders at 50px; ask the CDN for the small version instead of
      // pulling a full-size original for a thumbnail.
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }
    function v1GetDrawerThumbSrc(selectedVariant) {
      var variantSrc =
        selectedVariant &&
        selectedVariant.featured_image &&
        selectedVariant.featured_image.src;
      return v1SizedImage(variantSrc || v1GetProductFeaturedImage(), 100);
    }
    /*
      Called from every path that resolves a variant, not only from the mutation
      pass. The main observer runs with attributes:false, so a selection that
      only toggles classes on .dimension_val would not necessarily schedule a
      pass — the thumbnail would then lag behind the chosen variant. Driving it
      from the variant-resolution points makes it deterministic.

      Cheap to call repeatedly: one querySelector plus a string compare, and it
      writes only when the src actually differs.
    */
    var v1VariantById = null;
    function v1GetVariantById(id) {
      if (!id) {
        return null;
      }
      // Index built once. v1GetVariantData() re-parses the whole variant JSON
      // on every call, so scanning it per thumbnail update would re-parse the
      // full list on every pass; this is one parse and an O(1) lookup after.
      if (!v1VariantById) {
        v1VariantById = {};
        var variants = v1GetVariantData();
        for (var i = 0; i < variants.length; i++) {
          v1VariantById[String(variants[i].id)] = variants[i];
        }
      }
      return v1VariantById[String(id)] || null;
    }
    function v1UpdateDrawerThumb(selectedVariant) {
      /*
        Resolve from the product form's current variant id first.

        v1FindSelectedVariant() matches on category + dimension only, so on a
        3-option product (Category / Dimension / Colour — e.g. the reversible
        comforter) it returns the FIRST colour variant whatever swatch is
        actually active, and the thumbnail never follows the colour. The form
        input is the authoritative selection and the theme keeps it correct for
        every option, so read that and fall back to the passed variant.
      */
      var formInput = document.querySelector('product-form input[name="id"]');
      var variant = v1GetVariantById(formInput && formInput.value) || selectedVariant;
      var src = v1GetDrawerThumbSrc(variant);
      var img = document.querySelector('.variantItemImgTitle img');
      if (src && img && img.getAttribute('src') !== src) {
        img.setAttribute('src', src);
      }
    }
    // True when `el` is hidden by its own styling or by anything between it and
    // `root` (inclusive). Stops at `root` on purpose so a caller can ask "is this
    // hidden INSIDE this component" without the answer depending on whatever the
    // component itself is nested in.
    function v1IsHiddenWithin(el, root) {
      var stopAt = root && root.parentNode;
      for (var node = el; node && node !== stopAt && node.nodeType === 1; node = node.parentElement) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') {
          return true;
        }
      }
      return false;
    }
    function v1ReplaceRupeeTextNodes(root, priceText, skipElement) {
      if (!root || !priceText) return;
      var walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            if (skipElement && skipElement.contains(node.parentElement)) {
              return NodeFilter.FILTER_REJECT;
            }
            return /₹\s*[\d,]+/.test(node.nodeValue)
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_SKIP;
          }
        }
      );
      var nodes = [];
      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }
      nodes.forEach(function (node) {
        node.nodeValue = node.nodeValue.replace(/₹\s*[\d,]+/g, priceText);
      });
    }
    function v1UpdateATCPriceOnly(selectedVariant) {
      if (!selectedVariant) return;
      var priceText = v1FormatMoney(selectedVariant.price);
      if (!priceText) return;
      var isAvailable = selectedVariant.available !== false;
      /*
        MAIN PDP ATC
        buy-buttons.liquid already renders:
        Add to cart - {% render 'price' %}
        So only replace the price nodes, not the full button text.
      */
      document.querySelectorAll('.product-form__submit .atc-pdp').forEach(function (atcPdp) {
        if (!isAvailable) {
          atcPdp.textContent = 'Notify Me';
          return;
        }
        var labelSet = false;
        Array.prototype.slice.call(atcPdp.childNodes).forEach(function (node) {
          if (node.nodeType === 3) {
            if (!labelSet) {
              node.nodeValue = 'Add To Cart - ';
              labelSet = true;
            } else {
              node.nodeValue = '';
            }
          }
        });
        if (!labelSet) {
          atcPdp.insertBefore(document.createTextNode('Add To Cart - '), atcPdp.firstChild);
        }
        var priceNodes = atcPdp.querySelectorAll(
          '.price-item, ' +
          '.price-item--sale, ' +
          '.price-item--regular, ' +
          '.v1-main-atc-price'
        );
        if (priceNodes.length) {
          priceNodes.forEach(function (priceNode) {
            priceNode.textContent = priceText;
          });
        } else {
          atcPdp.insertAdjacentHTML(
            'beforeend',
            '<span class="v1-main-atc-price">' + priceText + '</span>'
          );
        }
      });
      /*
        STICKY ATC
        If sticky already has a separate price area after |,
        keep btn text as "Add To Cart" and update only price.
      */
      document.querySelectorAll(
        '.product-main-sticky-bar .sticky-addtocart-btn, ' +
        '.sticky-addtocart-btn'
      ).forEach(function (stickyBtn) {
        var btnText = stickyBtn.querySelector('.btn-text');
        if (!isAvailable) {
          if (btnText) btnText.textContent = 'Notify Me';
          return;
        }
        var stickyPriceNodes = stickyBtn.querySelectorAll(
          '.price-item, ' +
          '.sticky-price, ' +
          '.v1-sticky-atc-price'
        );
        /*
          "Already has its own price area" only counts if that area is VISIBLE.

          The sticky button's price span is server-rendered inside the button but
          ships carrying `hidden` (ctm-sticky-add-to-cart.liquid:99-100), and the
          only thing that unhides it is the theme's
          updateStickyBarForATCVerifyButton(3) (product-info.js:845-853) - which
          the custom-size path never calls. product-info.js:2296 does try to force
          it open with an inline display:inline, but `.hidden` is
          display:none !important, so it loses and the span stays invisible.

          Testing the button's textContent, as this did, therefore reported "there
          is a price" for a price nobody can see: the label dropped its own copy
          and the sticky ATC read a bare "Add To Cart" beside a PDP ATC reading
          "Add To Cart - <the custom price>". Reading real visibility puts the
          price back in the label exactly when the separate area cannot show it.

          Visibility is measured only up to stickyBtn, never past it - whether the
          sticky BAR is currently on screen is a scroll-position question and must
          not change what the label says.
        */
        var hasSeparatePrice = false;
        for (var v1PriceIndex = 0; v1PriceIndex < stickyPriceNodes.length; v1PriceIndex++) {
          if (!v1IsHiddenWithin(stickyPriceNodes[v1PriceIndex], stickyBtn)) {
            hasSeparatePrice = true;
            break;
          }
        }
        if (btnText) {
          btnText.textContent = hasSeparatePrice
            ? 'Add To Cart'
            : 'Add To Cart - ' + priceText;
        }
        if (stickyPriceNodes.length) {
          stickyPriceNodes.forEach(function (priceNode) {
            priceNode.textContent = priceText;
          });
        } else if (hasSeparatePrice) {
          // v1ReplaceRupeeTextNodes(stickyBtn, priceText, btnText);
        }
      });
    }
    function v1SyncSelectedVariantAndPrice(forcedVariant) {
      var selectedVariant = forcedVariant || v1FindSelectedVariant();
      if (!selectedVariant) {
        return;
      }
      v1SelectedVariantId = selectedVariant.id;
      document.body.classList.remove('v1NoSizeSelected');
      var priceText = v1FormatMoney(selectedVariant.price);
      if (!priceText) {
        return;
      }
      var atcText = selectedVariant.available === false
        ? 'Notify Me'
        : 'Add To Cart - ' + priceText;
      document.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], ' +
        '.product-form form input[name="id"], ' +
        'product-form form input[name="id"]'
      ).forEach(function (input) {
        if (String(input.value) !== String(selectedVariant.id)) {
          input.value = selectedVariant.id;
          input.setAttribute('value', selectedVariant.id);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      var selectedVariantScript = document.querySelector('variant-selects script[data-selected-variant]');
      if (selectedVariantScript) {
        var json = JSON.stringify(selectedVariant);
        selectedVariantScript.textContent = json;
        selectedVariantScript.innerHTML = json;
      }
      var variantSelects = document.querySelector('variant-selects');
      if (
        variantSelects &&
        typeof variantSelects.renderProductInfo === 'function'
      ) {
        variantSelects.currentVariant = selectedVariant;
        variantSelects.renderProductInfo();
      }
      document.querySelectorAll('.atcActiveTxt span').forEach(function (el) {
        if (el.textContent !== priceText) {
          el.textContent = priceText;
        }
      });
      document.querySelectorAll('.variantBtmCTA .atcActiveTxt').forEach(function (el) {
        var span = el.querySelector('span');
        if (span) {
          if (span.textContent !== priceText) {
            span.textContent = priceText;
          }
        } else {
          var newText = 'Add To Cart - ' + priceText;
          if (el.textContent !== newText) {
            el.textContent = newText;
          }
        }
      });
      v1UpdateATCPriceOnly(selectedVariant);
      v1UpdateDrawerThumb(selectedVariant);
      v1UpdateDeliveryBlock();
      // document.querySelectorAll(
      //   '.product-main-sticky-bar .sticky-addtocart-btn .btn-text, ' +
      //   '.sticky-addtocart-btn .btn-text, ' +
      //   '.custom_buy_button.atc-button .btn-text, ' +
      //   '.custom_buy_button.atc-button span, ' +
      //   'button[name="add"] .btn-text, ' +
      //   'button[name="add"] span'
      // ).forEach(function (el) {
      //   if (!el.textContent.toLowerCase().includes('sold out') && el.textContent !== atcText) {
      //     el.textContent = atcText;
      //   }
      // });
    }
    function v1CommitSelectedVariantToMainATC() {
      /*
        CUSTOM SIZE: commit the theme's matched variant, never the chip's.

        Everything below reads the '.dimension_val.selected' chip directly — it
        does not go through v1FindSelectedVariant() — so the custom-size
        short-circuit there does not cover this function. Without this branch,
        closing the sheet (which calls this three times) re-stamped the previously
        chosen STANDARD variant onto the buy form, the URL and the sticky ATC's
        price, while .custom_buy_button kept the real custom price. That is the
        sticky-vs-PDP price mismatch.

        v1SyncSelectedVariantAndPrice() covers the steps that still apply here
        (buy-form id, drawer CTA, both ATC prices, thumbnail, delivery block). The
        steps it omits are ones custom size does not use: the dimension chip's
        text, properties[_VariantTitle] and properties[_custom_size] are all
        supplied by custom.js's own AJAX payload (custom.js:830-874), which is the
        path the ATC takes once .buy-buttons-block loses `active`
        (product-info.js:1837).
      */
      if (v1IsCustomSizeActive()) {
        var customSizeVariant = v1GetCustomSizeVariant();
        if (customSizeVariant) {
          v1SelectedVariantId = customSizeVariant.id;
          v1SyncSelectedVariantAndPrice(customSizeVariant);
        }
        return;
      }
      var selectedDimensionEl = document.querySelector(
        '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
      );
      if (!selectedDimensionEl) {
        return;
      }
      var dimensionValue = v1GetDimensionValue(selectedDimensionEl);
      var selectedVariant = v1FindVariantForDimensionEl(selectedDimensionEl) || v1FindSelectedVariant();
      if (!selectedVariant || !dimensionValue) {
        return;
      }
      var priceText = v1FormatMoney(selectedVariant.price);
      var selectedCategory = v1GetSelectedCategory();
      v1SelectedDimension = dimensionValue;
      v1SelectedVariantId = selectedVariant.id;
      // 1. Update actual Shopify product form variant ID.
      document.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], ' +
        '.product-form form input[name="id"], ' +
        'product-form form input.product-variant-id, ' +
        'product-form form input[name="id"]'
      ).forEach(function (input) {
        input.value = selectedVariant.id;
        input.setAttribute('value', selectedVariant.id);
        if (selectedVariant.available === false) {
          input.setAttribute('disabled', 'disabled');
        } else {
          input.removeAttribute('disabled');
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // 2. Update hidden variant title property from buy-buttons.liquid.
      document.querySelectorAll('.variant-title-property').forEach(function (input) {
        input.value = selectedVariant.title || '';
        input.setAttribute('value', selectedVariant.title || '');
      });
      // 3. Update cover/custom size hidden property if present.
      document.querySelectorAll(
        'input.cover_properties[name="properties[_custom_size]"], ' +
        'input.mto_custom[name="properties[_custom_size]"]'
      ).forEach(function (input) {
        input.value = dimensionValue;
        input.setAttribute('value', dimensionValue);
      });
      // 4. Update main in-page selected size text.
      var selectedSizeText = selectedCategory
        ? selectedCategory + ' | ' + dimensionValue + ' inch'
        : dimensionValue + ' inch';
      var inpageSelectedSizeSpan = document.querySelector('.inpageSelectedSize span');
      if (inpageSelectedSizeSpan) {
        inpageSelectedSizeSpan.textContent = selectedSizeText;
        if (inpageSelectedSizeSpan.parentElement) {
          inpageSelectedSizeSpan.parentElement.setAttribute('data-value', selectedSizeText);
        }
      }
      // 5. Update drawer CTA price.
      document.querySelectorAll('.atcActiveTxt span').forEach(function (el) {
        el.textContent = priceText;
      });
      // 6. Update main PDP ATC button price from buy-buttons.liquid.
      document.querySelectorAll('.product-form__submit .atc-pdp').forEach(function (atcPdp) {
        var priceNodes = atcPdp.querySelectorAll(
          '.price-item.price-item--sale.price-item--last, ' +
          '.price__regular .price-item--regular, ' +
          '.price-item'
        );
        if (priceNodes.length) {
          priceNodes.forEach(function (priceNode) {
            priceNode.textContent = priceText;
          });
        } else {
          // atcPdp.innerHTML = selectedVariant.available === false
          //   ? 'Notify Me'
          //   : 'Add To Cart - <span class="v1-main-atc-price">' + priceText + '</span>';
          atcPdp.textContent = 'Add To Cart - ' + priceText;
        }
      });
      // 7. Update normal non-hybrid ATC button if present.
      document.querySelectorAll('.product-form__submit > span:not(.atc-pdp)').forEach(function (span) {
        span.textContent = selectedVariant.available === false
          ? 'Notify Me'
          : 'Add To Cart';
      });
      // 8. Enable/disable main submit button.
      document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function (button) {
        if (selectedVariant.available === false) {
          button.setAttribute('disabled', 'disabled');
        } else {
          button.removeAttribute('disabled');
        }
      });
      // 9. Update sticky ATC button text.
      document.querySelectorAll(
        '.product-main-sticky-bar .sticky-addtocart-btn .btn-text, ' +
        '.sticky-addtocart-btn .btn-text'
      ).forEach(function (el) {
        el.textContent = selectedVariant.available === false
          ? 'Notify Me'
          : 'Add To Cart - ' + priceText;
      });
      // 11. Update pickup availability variant id if present.
      document.querySelectorAll('pickup-availability').forEach(function (el) {
        el.setAttribute('data-variant-id', selectedVariant.id);
      });
      // 12. Also run your existing sync function once.
      if (typeof v1SyncSelectedVariantAndPrice === 'function') {
        v1SyncSelectedVariantAndPrice(selectedVariant);
      }
      v1UpdateATCPriceOnly(selectedVariant);
      v1UpdateDrawerThumb(selectedVariant);
      v1UpdateDeliveryBlock();
    }
    // REMOVED 2026-08-06: v1ForcePriceFromSelectedDimension() — dead. Its only
    // call site was already commented out; verified zero live references.
    function v1SetSelectedDimension(dimensionEl, shouldSyncInput) {
      if (!dimensionEl) {
        return;
      }
      /*
        CUSTOM SIZE hides the dimension picker, so nothing here can be a real
        shopper choice — the only caller that still reaches it is
        v1ApplyDimensionFilter(), which re-asserts whichever chip was left
        selected. Letting it through fired eight delayed writes below that put
        the previous standard size's price and id back on the ATC ~150ms after
        the shopper's custom dimensions had resolved.
      */
      if (v1IsCustomSizeActive()) {
        return;
      }
      var dimensionValue = v1GetDimensionValue(dimensionEl);
      if (!dimensionValue) {
        return;
      }
      // A dimension is being actively selected — from here on the MTO block
      // is allowed to show (subject to the variant actually matching one).
      v1UserSelectedSize = true;
      v1SelectedDimension = dimensionValue;
      document.querySelectorAll('.product_customDropdown.dimensions .dimension_val').forEach(function (el) {
        if (el === dimensionEl) {
          el.classList.add('selected');
          el.setAttribute('selected', 'selected');
        } else {
          el.classList.remove('selected');
          el.removeAttribute('selected');
        }
      });
      var dimensionButtonText = document.querySelector(
        '.product_customDropdown.dimensions .custom-dropdown-button-text'
      );
      if (dimensionButtonText) {
        dimensionButtonText.textContent = dimensionValue;
        dimensionButtonText.setAttribute('data-selected', dimensionValue);
      }
      var dimensionDropdown = document.querySelector(
        '.product_customDropdown.dimensions .dimension-custom-dropdown'
      );
      if (dimensionDropdown) {
        dimensionDropdown.classList.remove('noValSelected');
      }
      var matchedVariant = v1FindVariantForDimensionEl(dimensionEl);
      if (matchedVariant) {
        v1SelectedVariantId = matchedVariant.id;
      }
      if (shouldSyncInput !== false) {
        v1SelectHiddenDimensionInput(dimensionValue);
      }
      v1SyncSelectedVariantAndPrice(matchedVariant);
      setTimeout(function () {
        v1SyncSelectedVariantAndPrice(matchedVariant);
      }, 400);
      setTimeout(function () {
        v1SyncSelectedVariantAndPrice(matchedVariant);
      }, 900);
      v1CommitSelectedVariantToMainATC();
      setTimeout(v1CommitSelectedVariantToMainATC, 100);
      setTimeout(v1CommitSelectedVariantToMainATC, 400);
      setTimeout(v1CommitSelectedVariantToMainATC, 900);
      v1UpdateSelectedDimensionLine();
      v1UpdateDeliveryBlock();
    }
    var v1DimensionStyleInjected = false;
    function v1KeepDimensionListVisible() {
      // Flag instead of a #id lookup: this runs on every pass.
      if (!v1DimensionStyleInjected && !document.querySelector('#v1DimensionListFixStyle')) {
        v1DimensionStyleInjected = true;
        document.head.insertAdjacentHTML(
          'beforeend',
          '<style id="v1DimensionListFixStyle">' +
            'body.v1_c11074_j11355 .pdpVariantDrawer .product_customDropdown.dimensions .dimension_wrapper {' +
              'display: flex !important;' +
              'flex-wrap: wrap !important;' +
              'gap: 8px 10px !important;' +
              'align-items: stretch !important;' +
              'justify-content: flex-start !important;' +
              'list-style: none !important;' +
            '}' +
            'body.v1_c11074_j11355 .pdpVariantDrawer .product_customDropdown.dimensions .dimension_val:not(.hidden) {' +
              'display: flex !important;' +
              'flex: 0 0 calc(50% - 5px) !important;' +
              'width: calc(50% - 5px) !important;' +
              'max-width: calc(50% - 5px) !important;' +
              'box-sizing: border-box !important;' +
              'white-space: nowrap !important;' +
              'align-items: center !important;' +
              'justify-content: center !important;' +
              'text-align: center !important;' +
            '}' +
            'body.v1_c11074_j11355 .pdpVariantDrawer .product_customDropdown.dimensions .dimension_val.hidden {' +
              'display: none !important;' +
            '}' +
          '</style>'
        );
      }
      var dimensionDropdown = document.querySelector(
        '.product_customDropdown.dimensions .dimension-custom-dropdown'
      );
      if (!dimensionDropdown) {
        return;
      }
      var dimensionWrapper = dimensionDropdown.querySelector('.dimension_wrapper');
      // Only write when something actually differs -- these ran unconditionally
      // on every pass, invalidating style each time for no change.
      if (dimensionWrapper && (dimensionWrapper.style.display !== 'flex' || dimensionWrapper.classList.contains('hidden'))) {
        dimensionWrapper.classList.remove('hidden');
        dimensionWrapper.style.removeProperty('grid-template-columns');
        dimensionWrapper.style.setProperty('display', 'flex', 'important');
        dimensionWrapper.style.setProperty('flex-wrap', 'wrap', 'important');
      }
    }
    // Every unordered pair of option values that occur together on some variant,
    // as "a||b" both ways round. Built once from the variant JSON.
    //
    // This exists because the chip markup cannot answer "does this dimension belong
    // to that category?" on its own. product-variant-picker.liquid:631 hardcodes the
    // chip's category attribute to option1 (`dynamic_key = value.option1`) and never
    // emits option2 — fine when option1 IS the category, wrong when it is not.
    // mattress-cover is MATTRESS TYPE / CATEGORY / DIMENSION, so its chips advertise
    // "Ultima" as their category and the old data-option1 comparison hid every one.
    // Asking the variant data instead makes the match independent of option order.
    // Index: any option value -> the variants carrying it. Built once.
    // Lets a chip be checked against only the handful of variants sharing its
    // dimension rather than the whole list on every pass.
    var v1VariantsByOptionValue = null;
    function v1GetVariantsByOptionValue() {
      if (v1VariantsByOptionValue) {
        return v1VariantsByOptionValue;
      }
      var map = {};
      var variants = v1GetVariantData();
      for (var i = 0; i < variants.length; i++) {
        var opts = [variants[i].option1, variants[i].option2, variants[i].option3];
        for (var j = 0; j < opts.length; j++) {
          var key = String(opts[j] == null ? '' : opts[j]).trim().toLowerCase();
          if (!key) {
            continue;
          }
          if (!map[key]) {
            map[key] = [];
          }
          map[key].push(variants[i]);
        }
      }
      if (variants.length) {
        v1VariantsByOptionValue = map;
      }
      return map;
    }

    function v1VariantHasAllValues(variant, values) {
      var opts = [variant.option1, variant.option2, variant.option3];
      for (var i = 0; i < opts.length; i++) {
        opts[i] = String(opts[i] == null ? '' : opts[i]).trim().toLowerCase();
      }
      for (var v = 0; v < values.length; v++) {
        if (opts.indexOf(values[v]) === -1) {
          return false;
        }
      }
      return true;
    }

    // Every value that is genuinely a variant option value on this product.
    // The variant JSON is the only authoritative statement of that.
    var v1RealOptionValues = null;
    function v1GetRealOptionValues() {
      if (v1RealOptionValues) {
        return v1RealOptionValues;
      }
      var real = {};
      var variants = v1GetVariantData();
      for (var i = 0; i < variants.length; i++) {
        var opts = [variants[i].option1, variants[i].option2, variants[i].option3];
        for (var j = 0; j < opts.length; j++) {
          var value = String(opts[j] == null ? '' : opts[j]).trim().toLowerCase();
          if (value) {
            real[value] = true;
          }
        }
      }
      if (variants.length) {
        v1RealOptionValues = real;
      }
      return real;
    }

    // What the shopper has actually selected, as variant option values.
    //
    // THE RULE: a checked control constrains the match only if its value is a real
    // option value on this product.
    //
    // This is deliberately a validation, not a list of groups to skip. The picker
    // renders synthetic UI controls in the same markup as real options — most
    // notably the height chips, which are not a Shopify option on ANY product here
    // but are parsed out of the dimension string by
    // product-variant-picker.liquid:460-540, with `<input type="radio" name="height">`
    // carrying no value attribute at all (so it reads as the browser default "on").
    // Excluding such groups by class meant extending a blocklist every time one
    // turned up; checking against the variant data handles them, and anything added
    // later, without needing to know they exist.
    //
    // The dimension group is the one true structural exclusion: it is the list being
    // filtered, so letting its own selection constrain the match would collapse the
    // grid to the single chip already chosen.
    function v1GetActiveOptionValues() {
      var real = v1GetRealOptionValues();
      var values = [];
      document
        .querySelectorAll('variant-selects .variant-pill-list input[type="radio"]:checked')
        .forEach(function (input) {
          var group = input.closest('.variant-pill-list');
          if (
            !group ||
            group.classList.contains('dimension') ||
            group.classList.contains('dimension-size')
          ) {
            return;
          }
          var value = String(input.value || '').trim().toLowerCase();
          if (!value || !real[value]) {
            return;
          }
          if (values.indexOf(value) === -1) {
            values.push(value);
          }
        });
      return values;
    }

    // Only products that actually offer a height have one to filter by. Mattress
    // covers and the Founders mattress bake the height into the dimension string
    // ("72 x 30 x 9") and render no height picker, so requiring a height made the
    // old code bail out entirely and leave EVERY dimension visible regardless of
    // the chosen category.
    function v1HasHeightPicker() {
      return !!document.querySelector('.height_option');
    }

    function v1ApplyDimensionFilter() {
      var selectedCategory = v1GetSelectedCategory();
      var hasHeight = v1HasHeightPicker();
      var selectedHeight = hasHeight ? v1CleanNumber(v1GetCurrentHeight()) : '';
      if (!selectedCategory || (hasHeight && !selectedHeight)) {
        v1KeepDimensionListVisible();
        return;
      }
      if (hasHeight) {
        v1SetActiveHeight(selectedHeight);
      }
      var variantIndex = v1GetVariantsByOptionValue();
      var realOptionValues = v1GetRealOptionValues();
      var haveVariantData = v1GetVariantData().length > 0;
      var normalisedCategory = selectedCategory.trim().toLowerCase();
      // v1GetActiveOptionValues() normally picks the category up from its own
      // checked radio. This is a safety net for the case where the pill carries
      // .active but the radio has not been checked yet — and it is held to the same
      // rule, so a pseudo-category like "Custom Size" (a pill, never a variant
      // option value) cannot get in and fail every match.
      var activeValues = v1GetActiveOptionValues();
      if (
        v1GetRealOptionValues()[normalisedCategory] &&
        activeValues.indexOf(normalisedCategory) === -1
      ) {
        activeValues = activeValues.concat([normalisedCategory]);
      }
      var currentDimensionFromButton = document.querySelector(
        '.product_customDropdown.dimensions .custom-dropdown-button-text'
      );
      var currentDimensionValue = v1SelectedDimension;
      if (!currentDimensionValue && currentDimensionFromButton) {
        var buttonSelected = currentDimensionFromButton.getAttribute('data-selected') || '';
        var buttonText = currentDimensionFromButton.textContent.trim();
        if (buttonSelected && buttonSelected.toLowerCase() !== 'select a size') {
          currentDimensionValue = buttonSelected.trim();
        } else if (buttonText && buttonText.toLowerCase() !== 'select a size') {
          currentDimensionValue = buttonText.trim();
        }
      }
      var firstVisibleDimension = null;
      var selectedVisibleDimension = null;

      // Options the shopper picked OTHER than category/dimension — in practice
      // Colour. v1GetActiveOptionValues() above CANNOT see these: it is scoped to
      // '.variant-pill-list', and colour renders as '.product-form__input--swatch'.
      //
      // 2026-08-14: that blind spot was a real defect, not just a theoretical one.
      // On /products/mattress-protector, "84 x 72" exists ONLY for King/Grey — the
      // King/Blue set is 72x72, 75x72, 78x72. Picking King then Blue correctly showed
      // 3 chips, because the THEME's own colorOptionClickToSetDimensionDropDown()
      // (product-info.js:3650) DOES filter by colour. But closing and reopening the
      // sheet re-ran THIS filter, which re-showed all 4 — offering a Grey-only size
      // while Blue was selected. Two filters disagreeing; whichever ran last won.
      var otherSelectedValues = v1GetOtherSelectedOptionValues();

      var chipEls = [];
      document
        .querySelectorAll('.product_customDropdown.dimensions .dimension_val')
        .forEach(function (el) {
          chipEls.push(el);
        });

      function v1ChipMatches(el, extraValues) {
        var dimensionCategory = (el.getAttribute('data-option1') || '').trim();
        var dimensionHeight = v1GetDimensionHeight(el);
        var dimensionValue = v1GetDimensionValue(el);
        // Preferred: ask the variant data whether this category and this dimension
        // ever co-occur, which holds whatever position each option sits in.
        // Fall back to the original attribute comparison if the variant JSON is
        // missing or unparseable, so behaviour degrades to what it was before.
        var categoryMatches;
        if (haveVariantData && dimensionValue) {
          // A chip is not just a dimension — it is a (data-option1, dimension) pair,
          // which is exactly the key the picker de-duplicates on
          // (product-variant-picker.liquid:661). Its own data-option1 therefore has
          // to be part of the match.
          //
          // Without it, matching on the dimension string alone made BOTH mattress
          // types' chips pass whenever the two share a dimension: selecting
          // Ultima/Single/8in rendered "72 x 36 x 8" twice, once from each type's
          // chip. Verified on the live product — 8 of 24 category/height
          // combinations were duplicated; with this, 0.
          var requiredValues = activeValues.concat(extraValues || []);
          var chipOwnValue = dimensionCategory.toLowerCase();
          if (
            chipOwnValue &&
            realOptionValues[chipOwnValue] &&
            requiredValues.indexOf(chipOwnValue) === -1
          ) {
            requiredValues = requiredValues.concat([chipOwnValue]);
          }
          // Does ANY variant carry this dimension together with all of those? Only
          // the variants sharing this dimension are scanned, so this stays cheap
          // even on a 156-variant mattress.
          var candidates = variantIndex[String(dimensionValue).trim().toLowerCase()] || [];
          categoryMatches = false;
          for (var c = 0; c < candidates.length; c++) {
            if (v1VariantHasAllValues(candidates[c], requiredValues)) {
              categoryMatches = true;
              break;
            }
          }
        } else {
          categoryMatches = dimensionCategory.toLowerCase() === normalisedCategory;
        }
        return categoryMatches && (!hasHeight || dimensionHeight === selectedHeight);
      }

      // Decide every chip BEFORE touching the DOM, so a constraint that matches
      // nothing can be dropped rather than collapsing the grid to zero chips.
      //
      // This is the specific hazard flagged when colour was deliberately left out of
      // this filter (Session 7): while switching category, the site briefly leaves a
      // colour checked that does not exist under the newly picked category, and a
      // strict match would hide EVERY chip. Retrying without the extra values makes
      // the constraint additive-only — it can never show fewer chips than the
      // category-alone result did, which is exactly the old behaviour as a floor.
      var chipMatches = chipEls.map(function (el) {
        return v1ChipMatches(el, otherSelectedValues);
      });
      if (otherSelectedValues.length && chipMatches.indexOf(true) === -1) {
        chipMatches = chipEls.map(function (el) {
          return v1ChipMatches(el, []);
        });
      }

      chipEls.forEach(function (el, chipIndex) {
        var dimensionValue = v1GetDimensionValue(el);
        var isMatching = chipMatches[chipIndex];
        if (isMatching) {
          el.classList.remove('hidden');
          if (!firstVisibleDimension) {
            firstVisibleDimension = el;
          }
          if (currentDimensionValue && dimensionValue === currentDimensionValue) {
            selectedVisibleDimension = el;
          }
          if (!currentDimensionValue && el.classList.contains('selected')) {
            selectedVisibleDimension = el;
          }
        } else {
          el.classList.add('hidden');
          el.classList.remove('selected');
          el.removeAttribute('selected');
        }
      });
      // var dimensionToSelect = selectedVisibleDimension || firstVisibleDimension;
      // if (dimensionToSelect) {
      //   v1SetSelectedDimension(dimensionToSelect, true);
      // }
      if (selectedVisibleDimension) {
        v1SetSelectedDimension(selectedVisibleDimension, true);
      }
      v1KeepDimensionListVisible();
    }
    // True only once the shopper has actually picked a size.
    // A product with no dimension picker at all is left alone (its single
    // variant is effectively pre-chosen). For products WITH a dimension
    // picker we require v1UserSelectedSize — Shopify's default .selected in
    // the raw DOM does NOT count as a user choice — AND a still-selected
    // visible dimension in the DOM, so clearing the selection re-hides it.
    // REMOVED 2026-08-06: v1RefreshProductShape() — dead. Never called from
    // anywhere; the only surviving mention was inside a comment. It was the sole
    // writer of v1VariantCountKnown and v1IsSingleVariantProduct, both of which
    // were removed with it (v1IsSingleVariantProduct was never read at all).
    // v1HasDimensionPicker is NOT removed — v1HasSizeSelected below both writes
    // and reads it.
    function v1HasSizeSelected() {
        var dimensionDropdown = document.querySelector('.product_customDropdown.dimensions');
        if (dimensionDropdown) {
            v1HasDimensionPicker = true;
        }
        if (!v1HasDimensionPicker) {
            return true;
        }
        // CUSTOM SIZE path: this category doesn't use the dimension picker at
        // all — the shopper types length/width instead. So "size selected"
        // here means the Custom category is active AND both fields are filled.
        if (/custom/i.test(v1GetSelectedCategory() || '')) {
            var lengthInput = document.querySelector(
                '.custom-size-wrapper input[name="custom-length"]'
            );
            var widthInput = document.querySelector(
                '.custom-size-wrapper input[name="custom-width"]'
            );
            return !!(
                lengthInput && lengthInput.value &&
                widthInput && widthInput.value
            );
        }
        // PRE-SELECTED path: products with no height picker (Founder's, Cloud,
        // the mattress covers — they bake the height into the dimension string)
        // are never asked to re-pick. v1ResetInitialDimensionSelection() skips
        // its reset for exactly this case and commits the pre-selected variant
        // straight to the buy form, so the size genuinely IS selected and the
        // ATC is live from first paint.
        //
        // Requiring v1UserSelectedSize here anyway kept body.v1SizeNotSelected on,
        // and #v1MtoHideStyle hides .mto-message-container with !important while
        // that class is present — so on a product whose first size is MTO the
        // "Made to order… 3 days" line stayed invisible until the shopper opened
        // the sheet and tapped a size, even though MTOMessageManager had already
        // resolved STANDARD_MTO and unhidden it. Verified live on
        // /products/founders-mattress: state STANDARD_MTO, .mto-message--standard
        // without .hidden, computed display none.
        var v1HasHeightTab = document.querySelectorAll(
            '.product-form__input.height .height_option'
        ).length > 0;
        var v1PreSelectedDimension = document.querySelector(
            '.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'
        );
        if (!v1HasHeightTab) {
            return !!v1PreSelectedDimension;
        }
        // STANDARD path: require a real user dimension pick.
        return v1UserSelectedSize && !!v1PreSelectedDimension;
    }
    // Toggle the body class that the #v1MtoHideStyle CSS keys off. Called on
    // every mutation pass so it stays correct even when MTOMessageManager
    // flips inline styles on its own schedule.
    function v1SyncMtoGuardClass() {
      var hasSize = v1HasSizeSelected();
      document.body.classList.toggle('v1SizeNotSelected', !hasSize);
      /*
        The ATC gate is a SECOND class: body.v1NoSizeSelected, added once at init
        and hiding the real ATC in favour of the "Select Size" CTA
        (pdp-variant-sheet.css:747-755). Its only remover is
        v1SyncSelectedVariantAndPrice(), which needs a resolved variant — and in
        custom size mode there is none until the theme has matched one, so a
        shopper who went straight to Custom Size and closed the sheet was left
        looking at "Select Size" over a size they had already chosen.

        Lifted from v1HasSizeSelected()'s own custom-size answer (both length and
        width filled) so it does not depend on a variant having resolved yet.
        Remove-only, and scoped to custom size, so no other flow's gating changes.
      */
      if (hasSize && v1IsCustomSizeActive()) {
        document.body.classList.remove('v1NoSizeSelected');
      }
    }
    // ── DELIVERY / PINCODE BLOCK ─────────────────────────────────────────────
    // Replaces the sheet's previous MTO handling, which relocated the PDP's own
    // .mto-message-container in and out of the drawer on every pass and fought
    // MTOMessageManager for control of its inline styles.
    //
    // This block is self-contained: it owns its markup, renders at the END of the
    // SCROLLABLE picker row (NOT pinned above the ATC), and appears only when the
    // current selection is Made-To-Order or Custom Size.
    //
    // The PDP's own .mto-message-container is left alone. v1SyncMtoGuardClass()
    // above still sets body.v1SizeNotSelected, which the #v1MtoHideStyle rule uses
    // to stop that banner promising a dispatch time for a variant the shopper has
    // not actually chosen. Removing that guard would be a regression, so it stays.

    // {days} is filled per product by v1GetMtoDispatchDays() at render time —
    // see v1UpdateDeliveryBlock(). Hardcoding 3 here promised a 3-day dispatch on
    // every mattress, while the PDP's own MTO banner right above it (built from
    // snippets/mto-dispatch-days.liquid) correctly said 6 — or 9 on Founder's.
    var V1_DELIVERY_COPY = {
      mto: 'Made to order &middot; ships in <strong>{days} days</strong>',
      custom: 'Custom made &middot; ships in <strong>{days} days</strong>',
      // BEDS — deliberately carries NO made-to-order wording. A bed is not MTO; the
      // block is here purely so serviceability can be confirmed before add-to-cart,
      // which is what the copy now says outright: on a bed the pincode check is not
      // optional detail, it is the thing standing between the shopper and the cart.
      // `&amp;` because this is assigned via innerHTML (see v1UpdateDeliveryBlock).
      bed: 'Enter Pincode to check delivery &amp; add to cart'
    };


    // Shown when SHOPIFY says the selected size cannot be sold. Wording matches the
    // PDP's own out-of-stock language; single constant so it is one edit.
    var V1_OUT_OF_STOCK_COPY = 'This product is currently out of stock';

    // Same endpoint and payload shape as the PDP's own pincode widget
    // (assets/custom.js:1678). The bearer token is hardcoded there as well — this
    // is a third copy of an already-client-visible credential, not a new exposure,
    // but it does mean a rotation has to touch both files. Logged as tech debt.
    var V1_DELIVERY_ENDPOINT =
      'https://aws-api.sleepycat.in/api/shopify/fetch/delivery-timeline';
    var V1_DELIVERY_AUTH =
      'Bearer eyJhbGciOiJIUzI1NiJ9.dmFpYmhhdi5wYXJha2hAc2xlZXB5Y2F0Lmlu.ZB6HilINZe8PBFZ_SGYlWEEYAM6mBpDIxg5bEERvc1E';

    var V1_DELIVERY_ICONS = {
      ok:
        '<svg class="v1DelIcon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="8" fill="#1BA84F"/>' +
        '<path d="M4.5 8.2l2.3 2.3 4.7-4.7" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      areaError:
        '<svg class="v1DelIcon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="7.25" stroke="#D42B2B" stroke-width="1.5"/>' +
        '<path d="M5.6 5.6l4.8 4.8M10.4 5.6l-4.8 4.8" stroke="#D42B2B" stroke-width="1.5" stroke-linecap="round"/></svg>',
      formatError:
        '<svg class="v1DelIcon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="7.25" stroke="#D42B2B" stroke-width="1.5"/>' +
        '<path d="M8 4.3v4.4" stroke="#D42B2B" stroke-width="1.6" stroke-linecap="round"/>' +
        '<circle cx="8" cy="11.3" r="0.9" fill="#D42B2B"/></svg>',
      loading: ''
    };

    var V1_DELIVERY_MARKUP =
      '<div class="v1DeliveryBlock" hidden>' +
        '<div class="v1DeliveryStrip">' +
          '<svg class="v1DeliveryClock" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<circle cx="8" cy="8" r="6.6" stroke="#C8811F" stroke-width="1.3"/>' +
            '<path d="M8 4.6V8.2l2.4 1.5" stroke="#C8811F" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span class="v1DeliveryText"></span>' +
          '<button type="button" class="v1DeliveryToggle" aria-expanded="false" aria-controls="v1DeliveryPanel">' +
            '<span>Check pincode</span>' +
            '<svg class="v1DeliveryChevron" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
              '<path d="M2.5 3.75L5 6.25l2.5-2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="v1DeliveryPanel" id="v1DeliveryPanel" hidden>' +
          '<div class="v1DeliveryInputRow">' +
            '<input type="text" class="v1DeliveryPin" inputmode="numeric" autocomplete="postal-code" ' +
              'maxlength="6" placeholder="Enter delivery pincode" aria-label="Enter delivery pincode">' +
            '<button type="button" class="v1DeliveryCheck">CHECK</button>' +
          '</div>' +
          '<div class="v1DeliveryResult" role="status" aria-live="polite"></div>' +
        '</div>' +
      '</div>';

    // Guards against a slow response for an old pincode/variant overwriting a
    // newer one — the shopper can change size while a request is in flight.
    var v1DeliveryReqSeq = 0;

    function v1DeliveryBlockEl() {
      return document.querySelector('.main-pdp-variant-picker-row .v1DeliveryBlock');
    }

    function v1IsCustomSizeActive() {
      return /custom/i.test(v1GetSelectedCategory() || '');
    }

    /*
      The variant the theme's own custom-size matcher settled on.

      CUSTOM SIZE is a pseudo-category: it carries no radio and it hides the
      dimension picker (product-info.js:1850-1852), so NOTHING about the
      shopper's choice is readable from the pills. product-info.js's
      handleCustomChange() does the matching instead — it reads the length/width
      fields, finds the smallest stocked dimension that covers them, and writes
      that variant onto .custom_buy_button[data-variant-id] (:2211-2212, :2275).
      That attribute is the only authoritative answer while custom size is on.

      Returns null when the theme has not matched anything (blank attribute, or
      an id that is not in this product's variant data). Callers must treat that
      as "no selection" and leave the ATC alone rather than falling back to the
      pills — the pills describe a DIFFERENT, standard-size variant, and writing
      its price or its id onto the ATC is exactly the bug this replaced.
    */
    function v1GetCustomSizeVariant() {
      if (!v1IsCustomSizeActive()) {
        return null;
      }
      var customSizeCTA = document.querySelector('.custom_buy_button[data-variant-id]');
      return v1GetVariantById(customSizeCTA && customSizeCTA.getAttribute('data-variant-id'));
    }

    /*
      Can Shopify actually sell the selected size?

      Reads window.getVariantConfig (product-info.js:24), which is built from
      window.variantMetafields — server-rendered straight from Liquid's
      product.variants in main-product.liquid:667. That is the Shopify shop-location
      inventory and nothing else, which is the rule for this storefront: the delivery
      API's in_stock / available_inventory are NOT consulted anywhere here.

      All four conditions are required, spelling out the state rather than leaning on
      `available` alone:
        · not made-to-order    — an MTO size is deliberately qty 0 and still sellable
        · available === false  — Shopify's own verdict
        · tracked by Shopify   — an untracked variant has a meaningless quantity, so
                                 it must never be judged out of stock on one
        · qty <= 0 AND continue-selling off

      The last two are what `available === false` already implies for a tracked
      variant; stating them is what makes this unable to false-positive, and it is
      the exact condition being described — no inventory, and overselling turned off.
    */
    function v1SelectedVariantIsOutOfStock() {
      if (typeof window.getVariantConfig !== 'function') {
        return false;
      }
      // Same resolution order as v1SelectedVariantIsMTO below — the form input is
      // authoritative and correct in custom-size mode too.
      var variantId = '';
      var idInput = document.querySelector('product-form input[name="id"]');
      if (idInput && idInput.value) {
        variantId = idInput.value;
      } else {
        var variant = v1FindSelectedVariant();
        variantId = (variant && variant.id) || '';
      }
      if (!variantId) {
        return false;
      }
      var config = window.getVariantConfig(variantId);
      if (!config) {
        return false;
      }
      return (
        config.isMTO !== true &&
        config.available === false &&
        config.isTrackedByShopify === true &&
        config.inventoryQuantity <= 0 &&
        config.continueSellingWhenOOS === false
      );
    }

    function v1SelectedVariantIsMTO() {
      if (typeof window.getVariantConfig !== 'function') {
        return false;
      }
      // The form's variant input first, v1FindSelectedVariant() only as a fallback.
      //
      // Same root cause as the empty-SKU bug: v1FindSelectedVariant() needs either a
      // selected dimension chip or BOTH a category and a dimension, and returns null
      // in Custom Size mode and on shapes it does not recognise — so the MTO strip
      // silently never appeared. The theme keeps input[name="id"] pointed at the
      // real variant through every path, including custom size (product-info.js:2226).
      var variantId = '';
      var idInput = document.querySelector('product-form input[name="id"]');
      if (idInput && idInput.value) {
        variantId = idInput.value;
      } else {
        var variant = v1FindSelectedVariant();
        variantId = (variant && variant.id) || '';
      }
      if (!variantId) {
        return false;
      }
      // The theme's own four-condition MTO test (product-info.js:51-58):
      // is_mto metafield AND out of stock AND available AND oversell enabled.
      var config = window.getVariantConfig(variantId);
      return !!(config && config.isMTO);
    }

    // Appended to the SCROLLABLE row, so it scrolls with the options rather than
    // sitting in the fixed .variantBtmCTAWrap footer above the ATC.
    function v1BuildDeliveryBlock() {
      var row = document.querySelector('.main-pdp-variant-picker-row');
      if (!row || row.querySelector('.v1DeliveryBlock')) {
        return;
      }
      row.insertAdjacentHTML('beforeend', V1_DELIVERY_MARKUP);
    }

    function v1SetDeliveryExpanded(block, expanded) {
      var toggle = block.querySelector('.v1DeliveryToggle');
      var panel = block.querySelector('.v1DeliveryPanel');
      if (!toggle || !panel) {
        return;
      }
      panel.hidden = !expanded;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      block.classList.toggle('v1DeliveryOpen', !!expanded);
    }

    // The delivery block is the LAST thing in the sheet, and it grows twice:
    // expanding it (38px → 95px measured) pushes the pin code input below the
    // fold, and rendering the result pushes the timeline below it in turn. Both
    // times the part that gets clipped is exactly the part the shopper is
    // looking for. Nudge the sheet's scroller down by the amount that
    // overflowed, plus a little breathing room, so the whole block lands just
    // above the CTA. Called on expand and on every result state.
    //
    // Deliberately arithmetic on the scroller rather than scrollIntoView():
    // the drawer scrolls .main-pdp-variant-picker-row while the page body is
    // position:fixed under the scroll lock, and scrollIntoView() walks ancestors
    // — on iOS it will happily scroll the locked body instead and leave the
    // sheet where it was.
    var V1_DELIVERY_REVEAL_GAP = 12;
    function v1RevealDeliveryBlock(block) {
      var scroller = block.closest('.main-pdp-variant-picker-row');
      if (!scroller || !document.body.classList.contains('showVariantDrawer')) {
        return;
      }
      // One frame so the panel (hidden until a moment ago) has been laid out and
      // the block's height reflects the expanded state.
      requestAnimationFrame(function () {
        var blockRect = block.getBoundingClientRect();
        var scrollerRect = scroller.getBoundingClientRect();
        // The shopper has scrolled away from the block entirely — the timeline
        // arrives ~300ms after they tap Check, and yanking the sheet back to a
        // block they have deliberately scrolled off is worse than letting them
        // find it. Only reveal while they are still looking at it.
        if (blockRect.top >= scrollerRect.bottom) {
          return;
        }
        var overflowBelow = blockRect.bottom - scrollerRect.bottom;
        if (overflowBelow <= 0) {
          return;
        }
        var target = scroller.scrollTop + overflowBelow + V1_DELIVERY_REVEAL_GAP;
        try {
          scroller.scrollTo({ top: target, behavior: 'smooth' });
        } catch (err) {
          // Older WebKit: scrollTo(options) throws, plain assignment always works.
          scroller.scrollTop = target;
        }
      });
    }

    /*
      Point the shopper at the pincode check after a tap on the locked ATC.

      IN-SHEET COUNTERPART of the PDP's scrollToPincodeWithHighlight()
      (product-info.js:372), which scrolls the PAGE to .pincode-wrapper and pulses
      it. That is exactly the wrong move in here: the page is locked behind the
      overlay (v1LockBodyScroll pins the body), so a window scroll moves nothing the
      shopper can see, and the sheet has its own delivery block anyway — the PDP's
      .pincode-wrapper is a different element, behind the drawer.

      So this highlights in place. The only scrolling it does is v1RevealDeliveryBlock,
      which scrolls the DRAWER'S OWN container and only when the block is cut off at
      the bottom — highlighting something the shopper cannot see would be a no-op.

      Re-triggerable: the class is removed and the element reflowed before it goes
      back on, so a second tap replays the animation instead of doing nothing (the
      same reflow trick the PDP helper uses).
    */
    function v1PulseDeliveryBlock() {
      var block = v1DeliveryBlockEl();
      if (!block || block.hidden) {
        return;
      }
      v1RevealDeliveryBlock(block);
      block.classList.remove('v1DeliveryPulse');
      void block.offsetWidth;
      block.classList.add('v1DeliveryPulse');
    }

    function v1ClearDeliveryResult(block) {
      var el = block.querySelector('.v1DeliveryResult');
      if (el) {
        el.className = 'v1DeliveryResult';
        el.innerHTML = '';
      }
    }

    // `html` is always a literal from this file, or a date string built from a
    // parsed Date — never raw API text. The PDP widget injects the server's
    // message straight into innerHTML (custom.js:1698); this deliberately does not.
    function v1SetDeliveryResult(block, state, iconKey, html) {
      var el = block.querySelector('.v1DeliveryResult');
      if (!el) {
        return;
      }
      el.className = 'v1DeliveryResult v1DeliveryResult--' + state;
      el.innerHTML = (V1_DELIVERY_ICONS[iconKey] || '') + '<span>' + html + '</span>';
      // The result line is a THIRD growth step for a block that already sits at
      // the bottom of the sheet (38px closed → 95px open → ~120px with a
      // timeline, more when the date wraps), so the answer the shopper asked for
      // is the part that ends up clipped. Reveal on every state, not just the
      // success date: "Checking…" grows it first, so scrolling then means the
      // timeline lands in an already-correct view instead of jumping twice, and
      // the error copy ("we don't deliver here yet", out of stock) is just as
      // much the answer. Idempotent — a no-op whenever nothing overflows.
      v1RevealDeliveryBlock(block);
    }

    function v1FormatDeliveryDate(raw) {
      var date = new Date(raw);
      if (isNaN(date.getTime())) {
        return '';
      }
      // "Wednesday, 22 May"
      return (
        date.toLocaleDateString('en-GB', { weekday: 'long' }) +
        ', ' +
        date.getDate() +
        ' ' +
        date.toLocaleDateString('en-GB', { month: 'long' })
      );
    }

    function v1DeliveryTimestamp() {
      var now = new Date();
      function pad(value) {
        return String(value).padStart(2, '0');
      }
      return (
        now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) +
        ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds())
      );
    }

    // Mirror the pincode into the PDP's own delivery field.
    //
    // The theme already treats localStorage `pincodeval` as store-wide memory for
    // this: custom.js:74-78 restores input#pincode from it on load, and :82-84
    // writes it whenever the PDP's own .pin-check is clicked. So we write BOTH —
    // the live input, so the PDP field is filled immediately on this page without a
    // reload, and the key, so it survives navigation like any other pincode entry.
    //
    // Deliberately does NOT set data-pincodestatus or run the PDP's own check.
    // That attribute gates the bed ATC (`bed_pro_invalid`, buy-buttons.liquid:16),
    // and marking it valid off the back of OUR lookup would ungate a product the
    // PDP itself has not verified. Value only — which is what was asked for.
    function v1SyncPincodeToPdp(pincode) {
      try {
        localStorage.setItem('pincodeval', pincode);
      } catch (e) {
        // DOM storage disabled/partitioned (a documented Android in-app webview
        // default) — the live input below still gets filled, so this is non-fatal.
      }
      document.querySelectorAll('input#pincode').forEach(function (input) {
        if (input.value !== pincode) {
          input.value = pincode;
        }
      });
    }

    // The reverse direction: if a pincode is already known (entered on the PDP, or
    // carried over from a previous page), show it in the sheet rather than an empty
    // box the shopper has to retype. Same key, same convention as above.
    function v1PrefillPincodeFromStore(block) {
      // Once only. This runs from v1UpdateDeliveryBlock, which fires on every
      // mutation pass — without the latch, a shopper who deliberately cleared the
      // field would have it refilled underneath them on the very next pass.
      if (block.dataset.v1PinPrefilled) {
        return;
      }
      block.dataset.v1PinPrefilled = '1';
      var input = block.querySelector('.v1DeliveryPin');
      if (!input || input.value) {
        return;
      }
      var known = '';
      try {
        known = localStorage.getItem('pincodeval') || '';
      } catch (e) {
        known = '';
      }
      if (!known) {
        var pdpInput = document.querySelector('input#pincode');
        known = (pdpInput && pdpInput.value) || '';
      }
      if (/^[1-9][0-9]{5}$/.test(known.trim())) {
        input.value = known.trim();
      }
    }

    // The SKU the delivery API is asked about.
    //
    // BUG THIS FIXES (2026-08-10): this used to read v1FindSelectedVariant().sku,
    // which returns null in CUSTOM SIZE mode — that helper needs either a selected
    // dimension chip or both a category and a dimension, and custom size hides the
    // dimension list. An empty sku went to the API, it could not resolve a product,
    // no delivery_date came back, and every pincode reported "we don't deliver
    // here yet" on custom size.
    //
    // The form's variant input is the reliable source: custom size resolves the
    // typed dimensions to a real variant and repoints it (product-info.js:2226),
    // so it is correct in both modes. data-variants is `product.variants | json`
    // (product-variant-picker.liquid:17), i.e. full variant objects including sku.
    function v1ResolveSku() {
      var idInput = document.querySelector('product-form input[name="id"]');
      var variantId = idInput && idInput.value;
      if (variantId) {
        var byId = v1GetVariantById(variantId);
        if (byId && byId.sku) {
          return byId.sku;
        }
      }
      var selected = v1FindSelectedVariant();
      if (selected && selected.sku) {
        return selected.sku;
      }
      // Last resort: the PDP's own attribute. Server-rendered from
      // selected_or_first_available_variant (main-product.liquid:2193) and, as far
      // as this theme goes, never updated on variant change — so it is a fallback,
      // not a source of truth.
      var pdpPin = document.querySelector('input#pincode');
      return (pdpPin && pdpPin.getAttribute('data-sku')) || '';
    }

    function v1RunPincodeCheck(block) {
      var input = block.querySelector('.v1DeliveryPin');
      if (!input) {
        return;
      }
      var pincode = (input.value || '').trim();
      // Indian PIN codes are 6 digits and never begin with 0.
      if (!/^[1-9][0-9]{5}$/.test(pincode)) {
        v1SetDeliveryResult(
          block, 'error', 'formatError', 'Please enter a valid 6-digit pin code'
        );
        return;
      }

      // Mirror it out as soon as the format is known good, not on success — the
      // shopper typed it and pressed Check, so it is theirs regardless of whether
      // the API can serve that area.
      v1SyncPincodeToPdp(pincode);

      var sku = v1ResolveSku();
      var seq = ++v1DeliveryReqSeq;
      v1SetDeliveryResult(block, 'loading', 'loading', 'Checking&hellip;');

      fetch(V1_DELIVERY_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: V1_DELIVERY_AUTH
        },
        body: JSON.stringify({
          // NUMBER, not the raw input string. The API is type-sensitive here and it
          // matters ONLY for beds: with "110075" a bed comes back
          // serviceable:false / productPinCodeCheck:"invalid" /
          // reason:"bed not allowed on this pincode", while 110075 returns
          // serviceable:true with a delivery date. Mattresses answer identically
          // either way, which is why this only ever showed up on beds.
          // The PDP's own widget has always sent a number (custom.js), so this
          // matches it rather than relying on the API tolerating a string.
          // Safe to coerce: the value is already validated as /^[1-9][0-9]{5}$/,
          // so there is no leading zero to lose.
          pincode: Number(pincode),
          sku: sku,
          iscustom: v1IsCustomSizeActive(),
          orderdate: v1DeliveryTimestamp()
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (payload) {
          if (seq !== v1DeliveryReqSeq) {
            return; // a newer check superseded this one
          }
          var result = payload && payload.response && payload.response.result;
          if (!result || typeof result !== 'object') {
            v1SetDeliveryResult(
              block, 'error', 'areaError', "Couldn't check right now. Please try again."
            );
            return;
          }

          // Branches on the response's STRUCTURED fields. It used to substring-match
          // the whole serialised result, which was actively wrong: the key name
          // `productPinCodeCheck` lowercases to "productpincodecheck" — containing
          // "pincode" — and its value on a blocked bed is "invalid", so a perfectly
          // valid pincode was reported to the shopper as "Please enter a valid
          // 6-digit pin code". Verified against the live API; both shapes are:
          //
          //   serviceable   { delivery_date, ETDAttr, isMTO, isMTOMsg, serviceable:true }
          //   blocked bed   { productPinCodeCheck:"invalid", serviceable:false,
          //                   reason:"bed not allowed on this pincode" }
          //
          // `serviceable` is a real boolean in BOTH, so nothing has to be inferred.

          // 1. Explicit non-serviceability. Checked first, and it outranks a stray
          //    delivery_date: for a bed this also re-locks add-to-cart, and wrongly
          //    unlocking is the costlier mistake.
          if (
            result.serviceable === false ||
            String(result.productPinCodeCheck || '').trim().toLowerCase() === 'invalid'
          ) {
            v1SetBedServiceable(false);
            v1SetDeliveryResult(
              block, 'error', 'areaError', "Sorry, we don't deliver here yet"
            );
            return;
          }

          // 2. Serviceable, but Shopify cannot sell this size.
          //
          // Checked BEFORE the date because an unbuyable size still comes back
          // serviceable WITH a delivery_date — measured on the Ohayo bed, where
          // Single / 78 x 36 (available:false, qty 0, continue-selling off) answered
          // "Delivery by Monday, 24 August" while the button beside it read
          // "Notify Me". Worse, falling through to the date branch called
          // v1SetBedServiceable(true) and OPENED the bed gate for a size that cannot
          // be added at all.
          //
          // Bed-scoped on purpose. Other product types cannot reach this state: the
          // block only renders for custom size or MTO on them, and both of those
          // resolve to a variant Shopify still sells (an MTO size is available:true
          // by definition). Scoping it says so, rather than relying on that holding.
          if (v1IsBedProduct() && v1SelectedVariantIsOutOfStock()) {
            // Serviceability was never the problem, but this is not a confirmation
            // of purchasability either — so the gate stays shut rather than opening
            // on a size that cannot be bought.
            v1SetBedServiceable(false);
            v1SetDeliveryResult(block, 'error', 'formatError', V1_OUT_OF_STOCK_COPY);
            return;
          }

          // 3. Serviceable, sellable, with a usable date.
          //
          // STOCK IS DELIBERATELY NOT READ HERE. The response also carries
          // in_stock / available_inventory from the warehouse system, and this
          // used to refuse on them. It no longer does: the storefront takes
          // inventory from the Shopify shop location and nothing else, so if
          // Shopify is willing to sell the variant the sheet must not overrule it.
          //
          // That rule is not cosmetic here — the two sources genuinely disagree.
          // Measured 2026-08-18 on the Ohayo bed: Shopify has Single / 78 x 36 at
          // 104 units and Double / 78 x 48 at 141, both inventoryPolicy DENY and
          // tracked, while this API answers available_inventory:0 for the same two
          // SKUs at every pincode tried. Acting on the API figure produced an
          // "out of stock" message under a live Add To Cart, and — because the
          // branch also called v1SetBedServiceable(false) — locked the bed gate on
          // a deliverable address purely on stock grounds.
          //
          // Availability now reaches the buttons only through Shopify's own
          // variant.available, which is what v1UpdateATCPriceOnly() already reads.
          var formatted = result.delivery_date
            ? v1FormatDeliveryDate(result.delivery_date)
            : '';
          if (formatted) {
            v1SetBedServiceable(true);
            v1SetDeliveryResult(
              block, 'ok', 'ok', 'Delivery by <strong>' + formatted + '</strong>'
            );
            return;
          }

          // 3. Neither a refusal nor a date. Not evidence either way, so the bed gate
          //    is left exactly as it was rather than opened or shut on a guess.
          //    NOTE: the "valid 6-digit pin code" message is raised ONLY by the
          //    client-side format check before the request — never from a response.
          v1SetDeliveryResult(
            block, 'error', 'areaError', "Couldn't check right now. Please try again."
          );
        })
        .catch(function () {
          if (seq !== v1DeliveryReqSeq) {
            return;
          }
          v1SetDeliveryResult(
            block, 'error', 'areaError', "Couldn't check right now. Please try again."
          );
        });
    }

    // Mirrors the PDP's own bed gate onto the sheet's CTA. `bed_pro_invalid` is the
    // theme's flag (buy-buttons.liquid:16); while it is present the in-page submit
    // refuses to add (custom.js:1463). The sheet's CTA reaches that same button via
    // the sticky one, so the add was already blocked — this just makes the sheet
    // SHOW that it is blocked instead of looking live and silently doing nothing.
    // Opens or shuts the theme's own bed gate off the back of a real API answer.
    // Deliberately drives `bed_pro_invalid` — the same flag the PDP uses — rather
    // than inventing a second lock, so the sheet and the PDP can never disagree
    // about whether this bed may be added.
    function v1SetBedServiceable(serviceable) {
      if (!v1IsBedProduct()) {
        return;
      }
      document.querySelectorAll('.buy-buttons-block').forEach(function (block) {
        block.classList.toggle('bed_pro_invalid', !serviceable);
      });
      v1SyncBedAtcGate();
    }

    function v1SyncBedAtcGate() {
      if (!v1IsBedProduct()) {
        return;
      }
      var blocked = !!document.querySelector('.buy-buttons-block.bed_pro_invalid');
      document.body.classList.toggle('v1BedAtcBlocked', blocked);
    }

    function v1UpdateDeliveryBlock() {
      v1SyncMtoGuardClass();
      v1BuildDeliveryBlock();
      v1SyncBedAtcGate();

      var block = v1DeliveryBlockEl();
      if (!block) {
        return;
      }

      var isCustom = v1IsCustomSizeActive();
      var isBed = v1IsBedProduct();
      // Beds always get the block: it is how the shopper confirms the address is
      // serviceable, which the ATC depends on.
      var shouldShow = v1HasSizeSelected() && (isCustom || isBed || v1SelectedVariantIsMTO());

      if (!shouldShow) {
        if (!block.hidden) {
          block.hidden = true;
          v1SetDeliveryExpanded(block, false);
          v1ClearDeliveryResult(block);
        }
        return;
      }

      block.hidden = false;
      v1PrefillPincodeFromStore(block);

      // .bed carries no {days} placeholder — it is not a made-to-order line —
      // so the replace is a no-op on that branch.
      var copy = (isCustom
        ? V1_DELIVERY_COPY.custom
        : isBed
        ? V1_DELIVERY_COPY.bed
        : V1_DELIVERY_COPY.mto
      ).replace('{days}', v1GetMtoDispatchDays());
      var textEl = block.querySelector('.v1DeliveryText');
      if (textEl && textEl.innerHTML !== copy) {
        textEl.innerHTML = copy;
      }
      /*
        The bed line is an INSTRUCTION, not a note, and it is much longer than the
        other two ("Enter Pincode to check delivery & add to cart" measures 263px at
        12px vs 160px for the old copy). The strip gives the text only 245px at a
        414px viewport and 151px at 320px, and .v1DeliveryText is nowrap+ellipsis —
        so on every phone it truncated to "...check delivery & add to..." and lost
        the very words that tell the shopper why the ATC is locked. Dropping the
        toggle label to buy width does not rescue it either: 238px at 320px, still
        short.

        So beds, and only beds, are allowed to wrap to a second line. The 38px
        one-line rule still holds for the MTO and custom lines, which fit. This
        block sits in the SCROLLABLE picker row, not the fixed footer, so the extra
        16px costs nothing but a little scroll.
      */
      block.classList.toggle('v1DeliveryBlock--bed', !!isBed);

      // A quoted delivery date belongs to one SKU. If the shopper changes size the
      // old answer is no longer true, so drop it rather than leave it on screen.
      var variant = v1FindSelectedVariant();
      var variantKey = String((variant && variant.id) || '') + '|' + (isCustom ? 'c' : 's');
      if (block.dataset.v1DeliveryKey !== variantKey) {
        block.dataset.v1DeliveryKey = variantKey;
        v1ClearDeliveryResult(block);
      }
    }
    var targetNode = document.querySelector('.product.product--medium'),
      config = { attributes: false, childList: true, subtree: true },
      mutationCallback = function () {
        v1NormaliseDimensionDropdownClass();
        /*
          Option groups are collected once per pass and the list is reused by
          both consumers below -- the single-value marking here and the label
          rewriting near the end. Scoped to the <variant-selects> element rather
          than written as a 'variant-selects .x' descendant selector: the
          descendant form makes the engine walk back up the tree from every
          candidate, and on a mattress PDP that is ~1000 elements.

          Marked here, before the in-page summary is built, because the summary
          now needs to know which groups offer a real choice. Marking is cached
          per node, so the reuse further down costs a key comparison.

          .product-type is filtered out in the selector to preserve today's
          behaviour: it is moved out of <variant-selects> a few lines below, so
          the label loop has never seen it.
        */
        var v1VariantSelectsEl = document.querySelector('variant-selects');
        var v1OptionGroups = v1VariantSelectsEl
          ? v1VariantSelectsEl.querySelectorAll(
              '.variant-pill-list:not(.product-type),' +
                '.product_customDropdown,' +
                '.product-form__input--swatch'
            )
          : [];
        var v1SelectedCategoryForPass = v1GetSelectedCategory();
        for (var v1GroupIndex = 0; v1GroupIndex < v1OptionGroups.length; v1GroupIndex++) {
          v1MarkSingleValueGroup(v1OptionGroups[v1GroupIndex], v1SelectedCategoryForPass);
        }
        var howToMeasureVidPop = document.querySelector('.sizechart-popup');
        if (howToMeasureVidPop && !document.querySelector('.howToMeasureVidOverlay')) {
          howToMeasureVidPop.insertAdjacentHTML('afterend', '<div class="howToMeasureVidOverlay"></div>');
        }
        // var mtoMessageContainer = document.querySelector('.mto-message-container');
        // if (mtoMessageContainer && !mtoMessageContainer.parentNode.querySelector('.selectSizeInpage')) {
        //   mtoMessageContainer.insertAdjacentHTML('beforebegin', '<div class="selectSizeInpage"><div class="selectSizeLabel">Select Size:</div><div class="inpageSelectedSize"><span>Select Size</span>' + downArrowSVG + '</div><p>Didn\'t get the size right? You can exchange it.</p></div>');
        // }
        var mtoMessageContainer = document.querySelector('.mto-message-container');
        // Use a global guard — the .selectSizeInpage should only exist once on the page,
        // regardless of where .mto-message-container currently lives.
        if (mtoMessageContainer && !document.querySelector('.selectSizeInpage')) {
          mtoMessageContainer.insertAdjacentHTML('beforebegin', '<div class="selectSizeInpage"><div class="selectSizeLabel">Select Size:</div><div class="inpageSelectedSize"><span>Select Size</span>' + downArrowSVG + '</div><p>Didn\'t get the size right? You can exchange it.</p></div>');
        }
        var customBuyCTA = document.querySelector('.custom_buy_button.atc-button');
        if (customBuyCTA && !document.querySelector('.inPageSelectSizeCTA')) {
          customBuyCTA.insertAdjacentHTML('beforebegin', '<div class="inPageSelectSizeCTA selectSizeCTA">Select Size</div>');
        }
        var stickyAddToCartCTA = document.querySelector('.product-main-sticky-bar .sticky-addtocart-btn');
        if (stickyAddToCartCTA) {
          if (!document.querySelector('.stickySelectSizeCTA')) {
            stickyAddToCartCTA.insertAdjacentHTML('beforebegin', '<div class="stickySelectSizeCTA selectSizeCTA">Select Size</div>');
          }
        }
        var pdpMainStickyBar = document.querySelector('.product-main-sticky-bar'),
          orgStickyATCBtn = pdpMainStickyBar && pdpMainStickyBar.querySelector('.sticky-addtocart-btn .btn-text'),
          inpageSelectedSizeSpan = document.querySelector('.inpageSelectedSize span'),
          checkedCategInput = document.querySelector('variant-selects .variant-pill-list.category input:checked'),
          selectedCategPillVal = (checkedCategInput && checkedCategInput.value && checkedCategInput.value.trim()) || '',
          customCategLabel = document.querySelector('variant-selects .variant-pill-list.category .custom-size.active label'),
          selectedCategCstmVal = (customCategLabel && customCategLabel.textContent && customCategLabel.textContent.trim()) || '',
          selDimEl = document.querySelector('.product_customDropdown.dimensions .dimension_val.selected:not(.hidden)'),
          dimBtnEl = document.querySelector('.product_customDropdown.dimensions .custom-dropdown-button-text'),
          selectedDimension =
            (selDimEl && selDimEl.dataset && selDimEl.dataset.value) ||
            (dimBtnEl && dimBtnEl.dataset && dimBtnEl.dataset.selected) ||
            '',
          dimensionParameter = 'inch';
        if (selectedCategCstmVal) {
          var lInp = document.querySelector(
            '.custom-size-wrapper input[name="custom-length"]'
          );
          var wInp = document.querySelector(
            '.custom-size-wrapper input[name="custom-width"]'
          );
          var hInp = document.querySelector(
            '.custom-size-wrapper input[name="custom-height"]'
          );
          var lengthVal = (lInp && lInp.value) || '';
          var widthVal = (wInp && wInp.value) || '';
          var heightVal = (hInp && hInp.value) || '';
          // FALLBACK HEIGHT
          if (!heightVal) {
            // Get currently selected size text from dropdown/button
            var existingDimensionText =
              v1SelectedDimension ||
              (dimBtnEl && dimBtnEl.getAttribute('data-selected')) ||
              (dimBtnEl && dimBtnEl.textContent) ||
              '';
            // Extract all numbers
            var matches = existingDimensionText.match(/\d+/g);
            // Third number is height
            if (matches && matches.length >= 3) {
              heightVal = matches[2];
            }
          }
          selectedDimension =
            lengthVal + ' x ' + widthVal + ' x ' + heightVal;
        }
        /*
          Joined conditionally. The original always wrote "<size> | <dimension>",
          which on every pillow-case PDP rendered as "| 28 x 18 inch" -- those
          products have no CATEGORY option, so both size vars are empty strings.
          Those products have no size in their variant data at all, so the fix is
          to write the separator only when both halves exist rather than to infer
          a size from somewhere else.

          Where there is no size, the summary leads with whatever the shopper
          does choose instead -- the colour on an ErgoVerse cushion or a pillow
          case, the pack size on a slim pillow. That is read from the groups
          still offering a choice, so nothing has to be assumed about which
          option means what.
        */
        var inpageSizeLabel =
          selectedCategPillVal + selectedCategCstmVal || v1GetDisplaySizeSource().value;
        if (!inpageSizeLabel) {
          inpageSizeLabel = v1GetChoosableOptionValues(v1OptionGroups).join(' | ');
        }
        var inpageDimensionLabel = selectedDimension
          ? selectedDimension + ' ' + dimensionParameter
          : '';
        var inpageSelectedValToAdd =
          inpageSizeLabel && inpageDimensionLabel
            ? inpageSizeLabel + ' | ' + inpageDimensionLabel
            : inpageSizeLabel + inpageDimensionLabel;
        if (pdpMainStickyBar) {
          if (orgStickyATCBtn && orgStickyATCBtn.textContent.toLowerCase().includes('notify me')) {
            document.body.classList.add('notifyMeCTAVisible');
          } else {
            document.body.classList.remove('notifyMeCTAVisible');
          }
          if (inpageSelectedSizeSpan) {
            if (!pdpMainStickyBar.classList.contains('hidden') && orgStickyATCBtn && orgStickyATCBtn.textContent.toLowerCase().includes('add to cart')) {
              document.body.classList.remove('orgAddToCartHidden');
              if (inpageSelectedSizeSpan.innerHTML != inpageSelectedValToAdd) {
                inpageSelectedSizeSpan.innerHTML = inpageSelectedValToAdd;
                inpageSelectedSizeSpan.parentElement.dataset.value = inpageSelectedValToAdd;
              }
            } else {
              document.body.classList.add('orgAddToCartHidden');
              if (document.querySelector('body.notifyMeCTAVisible')) {
                if (inpageSelectedSizeSpan.innerHTML != inpageSelectedValToAdd) {
                  inpageSelectedSizeSpan.innerHTML = inpageSelectedValToAdd;
                  inpageSelectedSizeSpan.parentElement.dataset.value = '';
                }
              } else {
                if (inpageSelectedSizeSpan.innerHTML != 'Select Size') {
                  inpageSelectedSizeSpan.innerHTML = 'Select Size';
                  inpageSelectedSizeSpan.parentElement.dataset.value = '';
                }
              }
            }
          }
        }
        var pdpVariantPickerRow = document.querySelector('.main-pdp-variant-picker-row');
        if (pdpVariantPickerRow && !document.querySelector('.pdpVariantDrawer')) {
          pdpVariantPickerRow.insertAdjacentHTML('beforebegin', '<div class="pdpVariantOverlay"></div><div class="pdpVariantDrawer"></div>');
          document.querySelector('.pdpVariantDrawer').insertAdjacentElement('beforeend', pdpVariantPickerRow);
          document.querySelector('.pdpVariantDrawer').insertAdjacentHTML('beforeend', '<div class="variantBtmCTAWrap"> <div class="variantBtmCTA"><div class="atcActiveTxt">Add To Cart - <span></span></div><div class="atcNotifyTxt">Notify Me</div></div> </div>');
        }
        // Move product-type fieldset out of the drawer to its inline position
        var productTypeFieldset = document.querySelector('variant-selects fieldset.product-type, variant-selects .variant-pill-list.product-type');
        var inpageSizeBlock = document.querySelector('.selectSizeInpage');
        if (productTypeFieldset && inpageSizeBlock && !productTypeFieldset.classList.contains('v1MovedOut')) {
          // Place it directly before the in-page "Select Size" block
          inpageSizeBlock.parentNode.insertBefore(productTypeFieldset, inpageSizeBlock);
          productTypeFieldset.classList.add('v1MovedOut');
        }
        // REMOVED 2026-08-09: the .v1MtoSlot + .mto-message-container re-parenting.
        // Every pass moved the PDP's live MTO node into a slot pinned above the ATC
        // when the drawer opened, and back under .selectSizeInpage when it closed.
        // That is what put the message in the fixed footer instead of the scroll
        // area, and moving a node MTOMessageManager holds cached references to
        // (product-info.js:130-144) was the reason this file needed a second
        // MutationObserver to keep re-asserting its own inline styles.
        //
        // The delivery block now renders inside the SCROLLABLE picker row and owns
        // its own markup, so nothing is relocated and the PDP's node is untouched.
        var html1 = '<div class="variantTitleWrap variantDrawerClose">Choose Variant' + downArrowSVG + '</div>';
        html1 += '<div class="variantItemImgTitle"><img src="" alt=""><p></p></div>';
        // Mattress PDPs only — see v1IsMattressProduct(). On Bedding, Pillow,
        // ErgoVerse etc. the block is simply never built.
        if (v1IsMattressProduct()) {
          html1 += '<div class="variantMeasureInfoWrap"><div class="variantVidIcon"><img src="https://useruploads.vwo.io/useruploads/1178734/images/9a3608705fe86a14f3750959f807e247_screenshot20251021at3.39.17pm1.png"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><foreignObject x="-1.09252" y="-1.09282" width="25.4081" height="25.4081"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(0.55px);clip-path:url(#bgblur_0_9106_3191_clip_path);height:100%;width:100%"></div></foreignObject><circle data-figma-bg-blur-radius="1.09282" cx="11.6115" cy="11.6112" r="11.6112" fill="white"></circle><path d="M17.389 11.2811C17.739 11.4939 17.739 12.0019 17.389 12.2147L9.2626 17.1579C8.89847 17.3794 8.43223 17.1172 8.43223 16.691V6.80475C8.43223 6.37855 8.89847 6.11643 9.2626 6.33792L17.389 11.2811Z" fill="#202020"></path><defs><clipPath id="bgblur_0_9106_3191_clip_path" transform="translate(1.09252 1.09282)"><circle cx="11.6115" cy="11.6112" r="11.6112"></circle></clipPath></defs></svg></div><p><span>1 in 4</span> customers get their <span>mattress size</span> wrong. Watch this quick video to measure your bed right.</p></div>';
        }
        var variantSelectsWrap = document.querySelector('.main-pdp-variant-picker-row > variant-selects');
        if (variantSelectsWrap && !document.querySelector('.variantTitleWrap')) {
          variantSelectsWrap.insertAdjacentHTML('afterbegin', html1);
        }
        /*
          Resolved once here and reused for the price below. v1GetVariantData()
          re-parses the whole variant JSON on every call, so a second lookup
          would parse all 49 variants again on every mutation pass.

          Replaces the previous '.product__media-wrapper .swiper-slide img'
          scrape, which resolves to nothing on this theme (that container has no
          images — the gallery is .cst-product-slider-wrapper), so the drawer
          thumbnail was left with an empty src.
        */
        var selectedVariantForDrawer = v1FindSelectedVariant();
        v1UpdateDrawerThumb(selectedVariantForDrawer);
        var itemTitle = document.querySelector('.product__title h1'),
          drawerItemTitle = document.querySelector('.variantItemImgTitle p');
        if (itemTitle && drawerItemTitle && drawerItemTitle.textContent != itemTitle.textContent) {
          drawerItemTitle.textContent = itemTitle.textContent;
        }
        var drawerPriceText = selectedVariantForDrawer ? v1FormatMoney(selectedVariantForDrawer.price) : '';
        var itemPrice = document.querySelector('.price-item.price-item--sale.price-item--last');
        var drawerBtmCTAPSpan = document.querySelector('.atcActiveTxt span');
        if (!drawerPriceText && itemPrice) {
          drawerPriceText = itemPrice.textContent.trim();
        }
        if (drawerPriceText && drawerBtmCTAPSpan && drawerBtmCTAPSpan.textContent !== drawerPriceText) {
          drawerBtmCTAPSpan.textContent = drawerPriceText;
        }
        // Same list collected at the top of the pass -- already marked, not re-queried.
        v1OptionGroups.forEach(function (a) {
          var thisLabel = a.querySelector('label.form__label, legend.form__label');
          /*
            A collapsed group already shows its value as static text below the
            label, so the label drops both the value and the "Choose"/"Select"
            verb -- there is nothing to choose.
          */
          var isSingleValue = v1IsSingleValueGroup(a);
          if (a.classList.contains('product-type')) {
            var sibling = a.querySelector('.variant-pill-list-wrap');
            if (sibling && window.innerWidth <= 768) {
              sibling.style.setProperty('--cols', '2');
            }
          }
          if (a.classList.contains('category')) {
            var selectedCategory = v1GetSelectedCategory();
            var categoryLabelText = isSingleValue
              ? 'Category:'
              : selectedCategory
              ? 'Choose Category: ' + selectedCategory
              : 'Choose Category:';
            if (thisLabel && thisLabel.textContent != categoryLabelText) {
              thisLabel.textContent = categoryLabelText;
            }
          } else if (a.classList.contains('height')) {
            var activeHeightOpt = v1GetCurrentHeight();
            var heightLabelText = isSingleValue
              ? 'Height:'
              : activeHeightOpt
              ? 'Select Height: ' + activeHeightOpt
              : 'Select Height:';
            if (thisLabel && thisLabel.textContent != heightLabelText) {
              thisLabel.textContent = heightLabelText;
            }
            var heightInfoWrap = a.querySelector('.heightInfoWrap');
            if (activeHeightOpt) {
              if (heightInfoWrap && heightInfoWrap.dataset.value != activeHeightOpt) {
                heightInfoWrap.remove();
                heightInfoWrap = null;
              }
              if (!heightInfoWrap && heightData[activeHeightOpt]) {
                a.insertAdjacentHTML('beforeend', '<div class="heightInfoWrap" data-value="' + activeHeightOpt + '"><img src="https://useruploads.vwo.io/useruploads/1178734/images/a023a08a21b4149674260f2a158da6ba_thumbupicon.png"><div><p>(' + activeHeightOpt + ' inch thickness)</p><p>' + heightData[activeHeightOpt] + '</p></div></div>');
              }
            }
          } else if (a.classList.contains('dimensions')) {
            // (The selected-value lookup that used to live here was removed with the
            // label change below — it fed nothing else.)
            // The chosen value is NOT appended here any more — v1SelectedDimensionLine
            // renders it on its own line directly beneath this row. Appending it as
            // well printed the size twice, once in the label and once below it.
            // isSingleValue keeps dropping the verb: with nothing to choose, "Select"
            // is a false affordance (see PROJECT_TRACKER Deviation #15).
            var dimensionLabelText = isSingleValue
              ? 'Dimension:'
              : 'Select Dimension:';
            if (thisLabel && thisLabel.textContent != dimensionLabelText) {
              thisLabel.textContent = dimensionLabelText;
            }
            var labelWrap = a.querySelector('.dimension-label-wrap');
            if (labelWrap) {
              labelWrap.classList.add('flexbox');
            }
          }
        });
        /*
          The in-page control is labelled for what it actually opens. "Select
          Size:" describes nothing on a product where no size can be chosen --
          the ErgoVerse cushions offer only a colour, the pillow cases only a
          colour -- so those fall back to the drawer's own heading, "Select
          Variant".

          Run here rather than in the summary block above because it depends on
          the single-value marking done in the loop that just finished; reading
          it earlier would use the previous pass's answer and show the wrong
          label on first paint.
        */
        var v1SizeOptionGroup = document.querySelector(
          'variant-selects .variant-pill-list.category, variant-selects .variant-pill-list.size'
        );
        var v1DimensionGroup = document.querySelector('.product_customDropdown.dimensions');
        var v1SizeIsChoosable =
          (!!v1SizeOptionGroup && !v1IsSingleValueGroup(v1SizeOptionGroup)) ||
          (!!v1DimensionGroup && !v1IsSingleValueGroup(v1DimensionGroup));
        var v1InpageLabelText = v1SizeIsChoosable ? 'Select Size:' : 'Select Variant:';
        var v1InpageLabel = document.querySelector('.selectSizeLabel');
        if (v1InpageLabel && v1InpageLabel.textContent !== v1InpageLabelText) {
          v1InpageLabel.textContent = v1InpageLabelText;
        }
        var dimensionDropVal = document.querySelector('.product_customDropdown.dimensions .custom-dropdown-button-text');
        if (dimensionDropVal) {
          var ddRoot = dimensionDropVal.closest('.dimension-custom-dropdown');
          if (!dimensionDropVal.dataset.selected) {
            ddRoot && ddRoot.classList.add('noValSelected');
          } else {
            ddRoot && ddRoot.classList.remove('noValSelected');
          }
        }
        // v1ApplyDimensionFilter();
        v1KeepDimensionListVisible();
        // Build/refresh the delivery block. Keeps body.v1SizeNotSelected in sync
        // (via v1SyncMtoGuardClass inside), re-appends the block if a Section
        // Rendering pass replaced the row, and shows or hides it for the current
        // MTO / Custom Size state.
        v1UpdateSelectedDimensionLine();
        v1UpdateDeliveryBlock();
        if (v1IsFirstLoad) {
          v1ResetInitialDimensionSelection();
          setTimeout(function () {
            v1UpdateDeliveryBlock();
          }, 100);
          v1IsFirstLoad = false;
        }
      };
    // REMOVED 2026-08-09: v1MtoObserver + v1WatchMtoContainers().
    // This was a SECOND MutationObserver — attributes:true, subtree:true, on every
    // .mto-message-container — whose only job was to re-assert an inline
    // display:none whenever MTOMessageManager wrote its own inline style. The
    // sheet no longer touches that container at all, so the observer, and the
    // style-write war it existed to win, are both gone.
    // The pure-CSS #v1MtoHideStyle guard still covers the pre-selection state.
    // Run once on init
    mutationCallback();
    /**
     * Re-entrancy-guarded MutationObserver.
     * The observer disconnects itself before invoking the callback
     * (which mutates the DOM) and re-connects after — preventing
     * the infinite loop while still letting EVERY relevant mutation
     * trigger a fresh pass (so the drawer/CTAs get injected as soon
     * as their parents appear in the DOM).
     */
    /*
      OPTIMISATION: observer-driven passes are coalesced to one per frame.

      Measured before this change: a single size tap produced ~27 full
      mutationCallback passes and 1,074 document.querySelector calls, because
      the theme emits a burst of mutations per interaction and every one of them
      ran a complete pass (~40 unscoped queries each).

      A burst within one frame now runs ONE pass. Nothing is lost: the passes in
      a burst are idempotent -- they inject only what is missing and write text
      only when it differs -- so the last one already determined the outcome.

      Immediacy is preserved where it matters: the direct mutationCallback()
      calls on drawer open/close and at init are untouched and still synchronous.
      The disconnect/reconnect re-entrancy guard is kept exactly as it was.
    */
    var v1PassScheduled = false;
    function v1RunPass() {
      v1PassScheduled = false;
      if (v1IsMutating) {
        return;
      }
      v1IsMutating = true;
      observer.disconnect();
      try {
        mutationCallback();
      } finally {
        observer.observe(targetNode, config);
        v1IsMutating = false;
      }
    }
    var observer = new MutationObserver(function () {
      if (v1IsMutating || v1PassScheduled) {
        return;
      }
      v1PassScheduled = true;
      window.requestAnimationFrame(v1RunPass);
    });
    observer.observe(targetNode, config);

    // ── BACKGROUND SCROLL LOCK ───────────────────────────────────────────────
    // `body { overflow: hidden }` (still set in the CSS as a belt-and-braces) does
    // NOT hold on iOS Safari — the page behind a fixed overlay keeps scrolling, and
    // on Android the address-bar collapse can still drag it. Pinning the body with
    // position:fixed at a negative offset is the reliable cross-browser lock.
    //
    // The offset has to be captured and restored by hand: position:fixed collapses
    // the body to the viewport, so the browser forgets the scroll position and the
    // shopper would otherwise be dumped at the top of the page on close.
    // The drawer itself is position:fixed, so it is unaffected by any of this.
    var v1ScrollLockY = 0;
    var v1ScrollLocked = false;
    function v1LockBodyScroll() {
      if (v1ScrollLocked) {
        return;
      }
      v1ScrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + v1ScrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      v1ScrollLocked = true;
    }
    function v1UnlockBodyScroll() {
      if (!v1ScrollLocked) {
        return;
      }
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      v1ScrollLocked = false;
      window.scrollTo(0, v1ScrollLockY);
    }
    // Single entry point for open/close so the lock can never drift out of sync
    // with the class — the previous code toggled the class from three places.
    // Serviceability is confirmed PER DRAWER SESSION, not once per page.
    //
    // The block lives in the DOM permanently — the drawer only slides in and out —
    // so without this a shopper who checked a pincode, added to cart and reopened
    // the sheet found the previous "Delivery by …" still on screen and add-to-cart
    // already unlocked. They could then change size and add a variant whose
    // serviceability was never checked.
    //
    // Re-locking drives the theme's own `bed_pro_invalid`, so the block is enforced
    // by the PDP's JS listener rather than only by the sheet's CSS — the CTA cannot
    // be clicked through if a stylesheet fails to apply. This does also re-lock the
    // PDP's own button, which is deliberate: one source of truth, and re-checking
    // costs the shopper one tap.
    //
    // The typed pincode is intentionally LEFT in the field. It saves retyping, and
    // with the result cleared and the CTA visibly disabled the required action —
    // press CHECK — is unambiguous.
    function v1ResetDeliveryConfirmation() {
      var block = v1DeliveryBlockEl();
      if (block) {
        v1ClearDeliveryResult(block);
      }
      // Discard any reply still in flight, so a slow response from before the
      // drawer was reopened cannot land and silently unlock the CTA again.
      v1DeliveryReqSeq++;
      v1SetBedServiceable(false);
    }

    function v1SetDrawerOpen(open) {
      if (open) {
        v1LockBodyScroll();
        document.body.classList.add('showVariantDrawer');
        v1ResetDeliveryConfirmation();
      } else {
        document.body.classList.remove('showVariantDrawer');
        v1UnlockBodyScroll();
      }
    }

    // Enter inside the pincode field must NOT submit the product form it is
    // nested in — that would add to cart instead of checking a pincode.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('.v1DeliveryPin')) {
        return;
      }
      e.preventDefault();
      var block = e.target.closest('.v1DeliveryBlock');
      if (block) {
        v1RunPincodeCheck(block);
      }
    });

    // Keep the field numeric regardless of keyboard (the numeric inputmode is a
    // hint, not a constraint — desktop and some Android keyboards ignore it).
    document.addEventListener('input', function (e) {
      if (!e.target.closest || !e.target.closest('.v1DeliveryPin')) {
        return;
      }
      var cleaned = e.target.value.replace(/\D/g, '').slice(0, 6);
      if (cleaned !== e.target.value) {
        e.target.value = cleaned;
      }
      // Editing the pincode invalidates the answer on screen. A delivery date
      // belongs to the pincode it was quoted for, so leaving it up while the
      // shopper types a different one shows a promise for the wrong address.
      // Bumping the sequence also discards any reply still in flight.
      var block = e.target.closest('.v1DeliveryBlock');
      if (block) {
        v1DeliveryReqSeq++;
        v1ClearDeliveryResult(block);
      }
    });

    /*
      Re-match after every edit to the custom length/width fields.
      Typing 75 x 40 instead of 60 x 24 lands on a different variant at a
      different price, and nothing in the sheet was watching for it — the ATC
      prices are only refreshed from the pill-driven paths, which custom size
      does not use.

      product-info.js binds handleCustomChange() to the inputs themselves
      (:2383-2384), so by the time this bubble-phase listener runs the theme has
      already re-matched and data-variant-id is current. The second, deferred
      pass covers the site's own later writes landing after ours.

      Cannot recurse: v1SyncSelectedVariantAndPrice() dispatches `input` on
      input[name="id"], which is in the buy form, not in .custom-size-wrapper.
    */
    document.addEventListener('input', function (e) {
      if (!e.target.closest || !e.target.closest('.custom-size-wrapper')) {
        return;
      }
      var syncCustomSize = function () {
        var customSizeVariant = v1GetCustomSizeVariant();
        if (customSizeVariant) {
          v1SelectedVariantId = customSizeVariant.id;
          v1SyncSelectedVariantAndPrice(customSizeVariant);
        }
      };
      syncCustomSize();
      setTimeout(syncCustomSize, 250);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.variantDrawerClose, .pdpVariantOverlay')) {
        v1SetDrawerOpen(false);
      }
      // ── Delivery block ────────────────────────────────────────────────────
      // Replaces the old '.mto-check-timeline' handler, which closed the drawer,
      // yanked .mto-message-container back onto the PDP and asked the shopper to
      // go and find the pincode box. The check now happens in place.
      //
      // Delegated on `document` to match the handlers above: the drawer's own
      // subtree is rebuilt by the mutation pass, so element-bound listeners would
      // not survive. Bubble phase is safe here — these nodes are inside the
      // drawer, away from the Swiper instances whose `preventClicks` cancels
      // clicks elsewhere on this page.
      var deliveryToggle = e.target.closest('.v1DeliveryToggle');
      if (deliveryToggle) {
        var toggleBlock = deliveryToggle.closest('.v1DeliveryBlock');
        if (toggleBlock) {
          var willExpand = deliveryToggle.getAttribute('aria-expanded') !== 'true';
          v1SetDeliveryExpanded(toggleBlock, willExpand);
          if (willExpand) {
            v1RevealDeliveryBlock(toggleBlock);
          }
        }
        return;
      }
      if (e.target.closest('.v1DeliveryCheck')) {
        var checkBlock = e.target.closest('.v1DeliveryBlock');
        if (checkBlock) {
          v1RunPincodeCheck(checkBlock);
        }
        return;
      }
      if (e.target.closest('.variantDrawerClose, .pdpVariantOverlay')) {
        v1CommitSelectedVariantToMainATC();
        v1SetDrawerOpen(false);
        mutationCallback();
        // Force the site's MTOMessageManager to re-evaluate now that the MTO
        // has moved back to its original parent. This re-runs the visibility
        // logic and refreshes its cached DOM element references.
        setTimeout(function () {
          if (window.MTOMessageManager) {
            var currentVariantInput = document.querySelector('product-form input[name="id"]');
            var currentVariantId = currentVariantInput && currentVariantInput.value;
            if (currentVariantId && typeof window.MTOMessageManager.updateForVariant === 'function') {
              window.MTOMessageManager.updateForVariant(currentVariantId);
            }
          }
        }, 50);
        setTimeout(v1CommitSelectedVariantToMainATC, 100);
        setTimeout(v1CommitSelectedVariantToMainATC, 400);
        return;
      }
      if (e.target.closest('.selectSizeCTA, .inpageSelectedSize')) {
        v1SetDrawerOpen(true);
        mutationCallback(); // run immediately so MTO moves into drawer
        setTimeout(function () {
          if (typeof v1ApplyDimensionFilter === 'function') {
            v1ApplyDimensionFilter();
          }
          if (typeof v1KeepDimensionListVisible === 'function') {
            v1KeepDimensionListVisible();
          }
          // Re-trigger MTOMessageManager so it picks up the MTO in its new
          // location (inside the drawer slot)
          if (window.MTOMessageManager) {
            var currentVariantInput = document.querySelector('product-form input[name="id"]');
            var currentVariantId = currentVariantInput && currentVariantInput.value;
            if (currentVariantId && typeof window.MTOMessageManager.updateForVariant === 'function') {
              window.MTOMessageManager.updateForVariant(currentVariantId);
            }
          }
        }, 100);
      }
      if (e.target.closest('.product_customDropdown.dimensions .dimension_val')) {
        var clickedDimension = e.target.closest('.product_customDropdown.dimensions .dimension_val');
        if (!clickedDimension.classList.contains('hidden')) {
          var clickedDimensionHeight = v1GetDimensionHeight(clickedDimension);
          if (clickedDimensionHeight) {
            v1SetActiveHeight(clickedDimensionHeight);
          }
          v1SetSelectedDimension(clickedDimension, true);
          v1KeepDimensionListVisible();
        }
      }
      if (e.target.closest('.height_option')) {
        var clickedHeight = e.target.closest('.height_option');
        v1SelectedHeight = v1CleanNumber(
          clickedHeight.getAttribute('data-value') || clickedHeight.textContent
        );
        v1SelectedDimension = '';
        v1SelectedVariantId = '';
        setTimeout(function () {
          v1ApplyDimensionFilter();
        }, 80);
        setTimeout(function () {
          v1ApplyDimensionFilter();
        }, 350);
        setTimeout(function () {
          v1SyncSelectedVariantAndPrice(v1FindSelectedVariant());
        }, 700);
      }
      // ANY variant option group other than the dimension list invalidates that
      // list and must re-filter it — not just `.category`, which is all this used
      // to match. On mattress-cover the leading option is MATTRESS TYPE
      // (`.mattress-type`, class from `option.name | handleize` at
      // product-variant-picker.liquid:435), so switching Ultima <-> Hybrid Latex
      // never re-ran the filter and the other type's dimensions stayed on screen.
      //
      // The three exclusions below are NOT a "what counts as an option" list —
      // that question is answered from the variant data in v1GetActiveOptionValues().
      // These are groups that already own their own click handler, so letting this
      // branch also fire would double-run the filter on different timings:
      //   · .dimension / .dimension-size — the list itself, handled above
      //   · .height                      — handled above, at 80ms/350ms
      //   · .product-type                — navigates to another product entirely
      var v1ChangedOptionGroup = e.target.closest('variant-selects .variant-pill-list');
      if (
        v1ChangedOptionGroup &&
        !v1ChangedOptionGroup.classList.contains('dimension') &&
        !v1ChangedOptionGroup.classList.contains('dimension-size') &&
        !v1ChangedOptionGroup.classList.contains('height') &&
        !v1ChangedOptionGroup.classList.contains('product-type')
      ) {
        var activeHeightEl = document.querySelector('.height_option.active');
        var firstHeightEl = document.querySelector('.height_option');
        v1SelectedHeight = v1CleanNumber(
          v1SelectedHeight ||
          activeHeightEl?.getAttribute('data-value') ||
          activeHeightEl?.textContent ||
          firstHeightEl?.getAttribute('data-value') ||
          ''
        );
        v1SelectedDimension = '';
        v1SelectedVariantId = '';
        // If the user left Custom Size's length/width blank and switched to
        // a standard category, those hidden fields stay empty and the
        // site's own custom-size validation keeps the ATC disabled
        // regardless of the new category. Backfill defaults so it sees
        // valid values.
        if (!/custom/i.test(v1GetSelectedCategory() || '')) {
          v1EnsureCustomSizeDefaults();
        }
        setTimeout(function () {
          v1ApplyDimensionFilter();
        }, 200);
        setTimeout(function () {
          v1SyncSelectedVariantAndPrice(v1FindSelectedVariant());
        }, 500);
      }
      /*
        The locked CTA cannot receive its own clicks — .v1BedAtcBlocked sets
        pointer-events:none on .variantBtmCTA — so the tap lands on the WRAP behind
        it and, until now, did nothing at all. Verified on the Ohayo bed: the tap
        target is .variantBtmCTAWrap and no handler ran.

        Listening on the wrap turns that dead tap into the cue, without making the
        button itself clickable: the branch below still cannot fire, so nothing can
        be added while the gate is shut.

        Checked BEFORE the .variantBtmCTA branch because a tap on the wrap is only
        ever a blocked tap; once the gate opens, pointer-events returns and the
        button takes its own clicks again.
      */
      if (
        e.target.closest('.variantBtmCTAWrap') &&
        !e.target.closest('.variantBtmCTA') &&
        document.body.classList.contains('v1BedAtcBlocked')
      ) {
        v1PulseDeliveryBlock();
        return;
      }
      if (e.target.closest('.variantBtmCTA')) {
        v1CommitSelectedVariantToMainATC();
        var closeBtn = document.querySelector('.variantDrawerClose');
        var stickyBtn = document.querySelector('.product-main-sticky-bar .sticky-addtocart-btn');
        closeBtn && closeBtn.click();
        setTimeout(function () {
          v1CommitSelectedVariantToMainATC();
          stickyBtn && stickyBtn.click();
        }, 150);
      }
      if (e.target.closest('.variantMeasureInfoWrap')) {
        document.querySelector('.sizechart-popup-label')?.click();
      }
    });
        setTimeout(function () {
          document.body.classList.add('addAnim');
        }, 500);
      } else if (!document.getElementsByClassName('v1_c11074_j11355').length) {
        // Bounded retry. This previously recursed with no limit, so on any page
        // where .product.product--medium never appears (e.g. a merchant changes
        // the section's media_size setting) it would run a rAF callback every
        // frame for the life of the page. ~600 frames is roughly 10s at 60fps,
        // far longer than this PDP needs, then it gives up.
        window.__v1Attempts = (window.__v1Attempts || 0) + 1;
        if (window.__v1Attempts < 600) {
          window.requestAnimationFrame(v1_c11074_j11355);
        }
      }
    };

/*
  Mobile-only invocation gate. Everything above is the experiment script
  unchanged; this is the only addition.

  749px is the theme's canonical mobile breakpoint (min-width:750px x367 +
  max-width:749px x177 across the theme, vs max-width:768px x19).

  The gate is evaluated once, at script execution. It is deliberately NOT
  re-evaluated on resize: the script mutates the DOM irreversibly (it moves
  .main-pdp-variant-picker-row into a drawer it builds), so starting it after a
  desktop->mobile resize would relocate the picker with no way back. Rotating a
  phone stays within the breakpoint, so real mobile sessions are unaffected.
*/
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) {
    return;
  }
  window.v1_c11074_j11355();
})();
